import {
  addTo25e29vq105prw as addTo,
  Container7486fjmip554 as Container,
  SolidRect131p7hyzlx7j8 as SolidRect,
  Companion_instance1qzytx5vkv693 as Companion_instance,
  Text3kimhvgfxflj3 as Text,
  RoundRect16qm0yoxjizxs as RoundRect,
  centerOnqo5dp4jcubi5 as centerOn,
  addFixedUpdater1i013etalwvod as addFixedUpdater,
  alignLeftToLeftOf1gd7pnuyw0xa7 as alignLeftToLeftOf,
  alignRightToRightOf3d4tb0coiq6gi as alignRightToRightOf,
  Korge3fi4cwjkh8up9 as Korge,
  centerOnStage1tf2oda60yrak as centerOnStage,
  positionu6441b7hkb4l as position,
  Image1b2d7ghyim7p5 as Image,
  zIndex304xgfufia3na as zIndex,
  xy1gb51vhy014mx as xy,
  get_mouse1jstwhfaumelj as get_mouse,
  alignRightToLeftOf3v4uhguhiuzzk as alignRightToLeftOf,
  positionY2uokil6y98hyo as positionY,
  centerXOnStage2bkj8bzlu32ll as centerXOnStage,
  Scenezu810y12qpqp as Scene,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views116j359zi8nvf as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  SceneContainer99ijjqni12hp as SceneContainer,
  Companion_getInstance2b4rje0hs8ulh as Companion_getInstance,
  Stage1ggtrzujnnkl0 as Stage,
  GraphicsRenderer_GPU_getInstance3l98mt1a5bjlb as GraphicsRenderer_GPU_getInstance,
  Circlepba9jsmewo4k as Circle,
  scalea9fc0mbrr7ub as scale,
  onMouseDrag20om3ch85u2pf as onMouseDrag,
  draggableCloseable19eszn4jr7had as draggableCloseable,
  centerXBetweenqjpl7rjhq6xz as centerXBetween,
  alignLeftToLeftOfjh6f4sjag42i as alignLeftToLeftOf_0,
  centerYOnkz3i3jt5wqfb as centerYOn,
  alignLeftToRightOf25wtg1v682ku8 as alignLeftToRightOf,
  centerXOn3acn3bw226nj3 as centerXOn,
  centerYBetweenlw6rnmefjppz as centerYBetween,
  centerYOnStage363rojcpfesqp as centerYOnStage,
  positionX2hf0c1pfbo3wz as positionX,
} from './korge-root-korge.mjs';
import {
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3lu3946d91kk8 as Companion_getInstance_0,
  RectCorners2yrtl8r42p5bs as RectCorners,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_1,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_2,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance_3,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  RGBA34obx2i62wcl3 as RGBA,
  readSVG1bsgckm5esgfg as readSVG,
  scaled3gdp9stc6gl4n as scaled,
  render2gbt8tlw6dobg as render,
  readBitmapdk80pcjw6p8f as readBitmap,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Unit_instanceat14thlj150z as Unit_instance,
  numberToDouble210hrknaofnhf as numberToDouble,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  _Duration___get_inWholeSeconds__impl__hpy7b32mb043ng683qx as _Duration___get_inWholeSeconds__impl__hpy7b3,
  VOID7hggqo3abtya as VOID,
  Companion_getInstance148flmv2wtrla as Companion_getInstance_4,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Char__plus_impl_qi7pgjkmqmcttgys79 as Char__plus_impl_qi7pgj,
  toString14fd7g605f91p as toString,
  Paire9pteg33gng7 as Pair,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  equals2au1ep9vhcato as equals,
  Delegates_instance3jf2rsvdhmxzn as Delegates_instance,
  ArrayList3it5z8td81qkl as ArrayList,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  println2shhhgwwt4c61 as println,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  to2cs3ny02qtbcb as to,
  mapOf1xd03cq9cnmy8 as mapOf,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  toString30pk9tzaqopn as toString_0,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KtMap140uvy3s5zad8 as KtMap,
  Exceptiondt2hlxn7j7vw as Exception,
  toString1pkumu07cwy4m as toString_1,
  toDouble1kn912gjoizjp as toDouble,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  toInt2q8uldh7sc951 as toInt,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  Long2qws0ah9gnpki as Long,
  getKClass1s3j9wy1cofik as getKClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  Default_getInstancegttbt9h1yt0q as Default_getInstance,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  Enum3alwj03lh1n41 as Enum,
  abs1kdzbjes1idip as abs,
  until1jbpn0z3f8lbg as until,
  Collection1k04j3hzsbod0 as Collection,
  get_sign1dnxi33u9vk0c as get_sign,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  println29lx63wmxk0st as println_0,
  mutableMapOfk2y3zt1azl40 as mutableMapOf,
  toSet2orjxp16sotqu as toSet,
  minus2znw4oicpx34e as minus,
  plus310ted5e4i90h as plus,
  Companion_instance144r68bk89en4 as Companion_instance_0,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  intercepted2ogpsikxxj4u0 as intercepted,
  decodeToString1x4faah2liw2p as decodeToString,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_isEven24nr2rw87dlfj as get_isEven,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_5,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  WebSocketClient1u0rdag4ixzbi as WebSocketClient,
  Resources1ysf2j4wd5yk7 as Resources,
  Companion_getInstanceoov1tr749ham as Companion_getInstance_6,
  endpoint3q5iv6br97e50 as endpoint,
  Companion_getInstance1y2hlgoaquaip as Companion_getInstance_7,
} from './korlibs-io-root-korlibs-io.mjs';
import { Quality_QUALITY_getInstance3lqgkbt3e9vfv as Quality_QUALITY_getInstance } from './korge-root-korge-core.mjs';
import {
  toJsonn1f4824lp9qj as toJson,
  fromJson1zzawiiassmu2 as fromJson,
} from './korlibs-serialization-root-korlibs-serialization.mjs';
import { ChessClock3fxe921ed7qxr as ChessClock } from './sauronchess-Common.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  delay1f60wyf8ua1gc as delay,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
} from './kotlinx-coroutines-core.mjs';
import {
  get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD,
  getusdytp2za0u2 as get,
} from './korlibs-math-root-korlibs-math.mjs';
import { Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance } from './korlibs-logger-root-korlibs-logger.mjs';
import { readAll1pkrq4jwoqns4 as readAll } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Cell extends Container {
  static ybw(isWhite, cx, cy, text) {
    var $this = this.g9y();
    $this.ubw_1 = isWhite;
    $this.vbw_1 = cx;
    $this.wbw_1 = cy;
    var tmp = $this;
    // Inline function 'korlibs.korge.view.solidRect' call
    var width = DisplayConfig_getInstance().fbx();
    var height = DisplayConfig_getInstance().gbx();
    var color = Colors_getInstance().m3x_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = SolidRect.zbk(Size2D.s2e(width, height), color);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    tmp.xbw_1 = addTo(this_0, $this);
    moveCell($this, $this.vbw_1, $this.wbw_1);
    $this.ibx();
    // Inline function 'korlibs.korge.view.text' call
    var color_0 = Colors_getInstance().n3x_1;
    var textSize = Companion_instance.cbp_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_3().s4l_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.dbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Text.gbp(text, numberToDouble(textSize), color_0, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    addTo(this_1, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    return $this;
  }
  ibx() {
    var tmp;
    if (this.ubw_1) {
      tmp = UserSettings_instance.nbx_1 ? ThemeColors_getInstance().lbx_1 : ThemeColors_getInstance().jbx_1;
    } else {
      tmp = UserSettings_instance.nbx_1 ? ThemeColors_getInstance().mbx_1 : ThemeColors_getInstance().kbx_1;
    }
    this.xbw_1.bay(tmp);
  }
  rbx() {
    this.xbw_1.bay(Colors_getInstance().t3x_1);
  }
}
class Timer extends Container {
  static zc0($outer, color, timer, $box) {
    if ($box === VOID)
      $box = {};
    $box.yc0_1 = $outer;
    var $this = this.g9y(VOID, $box);
    var tmp = $this;
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.j27(80, 80);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    var radius = new RectCorners(numberToDouble(10), numberToDouble(10), numberToDouble(10), numberToDouble(10));
    var fill = new RGBA(color);
    var stroke = new RGBA(Colors_getInstance().m3x_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.qbi(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    tmp.xc0_1 = addTo(this_0, $this);
    // Inline function 'korlibs.korge.view.text' call
    var this_1 = $this.xc0_1;
    var text = _Duration___get_inWholeSeconds__impl__hpy7b3(timer.r1c_1).toString();
    var color_0 = Colors_getInstance().n3x_1;
    var textSize = Companion_instance.cbp_1;
    var font = get_DefaultTtfFontAsBitmap();
    var alignment = Companion_getInstance_3().s4l_1;
    var renderer = get_DefaultStringTextRenderer();
    var autoScaling = Companion_instance.dbp_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = Text.gbp(text, numberToDouble(textSize), color_0, font, alignment, renderer, autoScaling, null, null);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.text.<anonymous>' call
    var counter = addTo(this_2, this_1);
    centerOn(counter, $this.xc0_1);
    var tmp_0 = $this.xc0_1;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance_4();
    var tmp_1 = toDuration(50, DurationUnit_MILLISECONDS_getInstance());
    addFixedUpdater(tmp_0, tmp_1, VOID, VOID, ChessClockContainer$Timer$lambda(counter, timer));
    return $this;
  }
}
class ChessClockContainer extends Container {
  static lc3() {
    var $this = this.g9y();
    $this.ic3_1 = null;
    $this.jc3_1 = Timer.zc0($this, ThemeColors_getInstance().jbx_1, ensureNotNull(GameState_getInstance().iby_1).w1c_1);
    $this.kc3_1 = Timer.zc0($this, ThemeColors_getInstance().lbx_1, ensureNotNull(GameState_getInstance().iby_1).x1c_1);
    var tmp = $this;
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.j27(250, 100);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    var radius = new RectCorners(numberToDouble(10), numberToDouble(10), numberToDouble(10), numberToDouble(10));
    var fill = new RGBA(ThemeColors_getInstance().mbx_1);
    var stroke = new RGBA(Colors_getInstance().m3x_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.qbi(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    tmp.ic3_1 = addTo(this_0, $this);
    alignLeftToLeftOf(addTo_0(centerOn($this.jc3_1, ensureNotNull($this.ic3_1)), $this), ensureNotNull($this.ic3_1), 20);
    alignRightToRightOf(centerOn(addTo_0($this.kc3_1, $this), ensureNotNull($this.ic3_1)), ensureNotNull($this.ic3_1), 20);
    return $this;
  }
}
class GameState {
  constructor() {
    GameState_instance = this;
    this.sbx_1 = Delegates_instance.wn();
    this.tbx_1 = ArrayList.i1();
    this.ubx_1 = ArrayList.i1();
    this.vbx_1 = true;
    this.wbx_1 = true;
    this.xbx_1 = false;
    this.ybx_1 = false;
    this.zbx_1 = true;
    this.aby_1 = false;
    this.bby_1 = false;
    this.cby_1 = false;
    this.dby_1 = false;
    this.eby_1 = Delegates_instance.wn();
    this.fby_1 = null;
    this.gby_1 = ArrayList.i1();
    this.hby_1 = ArrayList.i1();
    this.iby_1 = null;
    this.jby_1 = null;
    this.kby_1 = true;
    this.lby_1 = true;
    this.mby_1 = 0;
    this.nby_1 = false;
    this.oby_1 = null;
  }
  sc6(_set____db54di) {
    return this.sbx_1.bo(this, sceneContainer$factory(), _set____db54di);
  }
  v9v() {
    return this.sbx_1.zn(this, sceneContainer$factory_0());
  }
  tc6(_set____db54di) {
    return this.eby_1.bo(this, settingsContainer$factory(), _set____db54di);
  }
  uc6() {
    return this.eby_1.zn(this, settingsContainer$factory_0());
  }
  d2q() {
    this.tbx_1.y2();
    this.ubx_1.y2();
    this.vbx_1 = true;
    this.wbx_1 = true;
    this.xbx_1 = false;
    this.ybx_1 = false;
    this.zbx_1 = true;
    this.aby_1 = false;
    this.bby_1 = false;
    this.cby_1 = false;
    this.dby_1 = false;
    this.fby_1 = null;
    this.gby_1.y2();
    this.hby_1.y2();
    this.lby_1 = true;
    this.mby_1 = 0;
    this.nby_1 = false;
    this.iby_1 = null;
    this.jby_1 = null;
    this.kby_1 = true;
    this.oby_1 = null;
    var tmp0_safe_receiver = get_wsClient();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.v33(1);
    }
  }
}
class Images {
  constructor() {
    this.ec6_1 = null;
    this.fc6_1 = null;
    this.gc6_1 = null;
    this.hc6_1 = null;
    this.ic6_1 = null;
    this.jc6_1 = null;
    this.kc6_1 = null;
    this.lc6_1 = null;
    this.mc6_1 = null;
    this.nc6_1 = null;
    this.oc6_1 = null;
    this.pc6_1 = null;
    this.qc6_1 = null;
  }
}
class DisplayConfig {
  constructor() {
    DisplayConfig_instance = this;
    this.zbw_1 = 900;
    this.abx_1 = 900;
    this.bbx_1 = 0.74;
    this.cbx_1 = this.zbw_1 * this.bbx_1;
    this.dbx_1 = this.abx_1 * this.bbx_1;
    this.ebx_1 = (this.zbw_1 - this.cbx_1) / 2;
  }
  hbx() {
    return (this.abx_1 - this.dbx_1) / 2;
  }
  gbx() {
    return this.dbx_1 / 8;
  }
  fbx() {
    return this.cbx_1 / 8;
  }
}
class ThemeColors {
  constructor() {
    ThemeColors_instance = this;
    this.jbx_1 = Colors_getInstance().e4d('#ebecd0');
    this.kbx_1 = Colors_getInstance().e4d('#964d22');
    this.lbx_1 = Colors_getInstance().e4d('#9a9c7c');
    this.mbx_1 = Colors_getInstance().e4d('#7a3a15');
  }
}
class UserSettings {
  constructor() {
    this.nbx_1 = false;
    this.obx_1 = false;
    this.pbx_1 = false;
    this.qbx_1 = false;
  }
}
class GameScene$sceneMain$lambda$slambda {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$slambda {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$lambda$slambda_0 {
  constructor($it) {
    this.vc6_1 = $it;
  }
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene extends Scene {
  wa0(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
class main$slambda {
  c9d($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$Korge), $completion);
  }
  pd(p1, $completion) {
    return this.c9d(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
class sendGameEnd$slambda {
  constructor($map) {
    this.ic7_1 = $map;
  }
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class handleGameEnd$slambda {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class timesUp$lambda$slambda {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class timesUp$lambda$slambda_0 {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class MoveIndicator extends Container {
  static vc9(cx, cy) {
    var $this = this.g9y();
    $this.rc9_1 = cx;
    $this.sc9_1 = cy;
    var tmp = $this;
    // Inline function 'korlibs.korge.view.circle' call
    var fill = new RGBA(Colors_getInstance().m3x_1);
    var stroke = new RGBA(Colors_getInstance().m3x_1);
    var renderer = GraphicsRenderer_GPU_getInstance();
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = Circle.yax(numberToDouble(16.0), fill, stroke, numberToDouble(0.0), true, renderer);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.circle.<anonymous>' call
    tmp.tc9_1 = addTo(this_0, $this);
    $this.uc9_1 = false;
    $this.wc9();
    $this.tc9_1.dac(2.0);
    return $this;
  }
  xc9() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.tc9_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'de.fsaurenbach.sauronchess.client.MoveIndicator.markRed.<anonymous>' call
    this_0.bay(Colors_getInstance().e4d('#cccccc'));
    this_0.cay(new RGBA(Colors_getInstance().r3x_1));
    this_0.day(new RGBA(Colors_getInstance().o3x_1));
    this_0.eay(6.5);
    this_0.aay(DisplayConfig_getInstance().bbx_1 * 39);
    this.uc9_1 = true;
  }
  wc9() {
    if (this.uc9_1)
      return this.xc9();
    // Inline function 'kotlin.apply' call
    var this_0 = this.tc9_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'de.fsaurenbach.sauronchess.client.MoveIndicator.markGrey.<anonymous>' call
    this_0.bay(Colors_getInstance().e4d('#3b3b3b81'));
    this_0.aay(DisplayConfig_getInstance().bbx_1 * 15);
    this_0.day(new RGBA(Colors_getInstance().n3x_1));
    this_0.eay(DisplayConfig_getInstance().bbx_1 * 3.1);
    this.uc9_1 = false;
  }
  yc9() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.tc9_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'de.fsaurenbach.sauronchess.client.MoveIndicator.markWhite.<anonymous>' call
    this_0.bay(Colors_getInstance().m3x_1);
    return this_0;
  }
}
class PieceKind extends Enum {}
class Piece$doMove$slambda {
  constructor(this$0, $promotionDialogue) {
    this.aca_1 = this$0;
    this.bca_1 = $promotionDialogue;
  }
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Piece$doMove$slambda_0 {
  constructor($map) {
    this.qcc_1 = $map;
  }
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Piece extends Container {
  static zc9(kind, color, cx, cy, disabled, isWhite) {
    disabled = disabled === VOID ? false : disabled;
    var $this = this.g9y();
    $this.uc5_1 = kind;
    $this.vc5_1 = color;
    $this.wc5_1 = disabled;
    $this.xc5_1 = isWhite;
    $this.yc5_1 = new Pair(cx, cy);
    $this.bc6_1 = false;
    $this.zc5_1 = $this.yc5_1;
    reloadImages($this);
    GameState_getInstance().ubx_1.h($this);
    movePiece($this, $this.cc6(), $this.dc6());
    var tmp = onMouseDrag($this, VOID, VOID, Piece$lambda($this));
    draggableCloseable($this, tmp, false, Piece$lambda_0($this));
    return $this;
  }
  cc6() {
    return this.yc5_1.zk_1;
  }
  dc6() {
    return this.yc5_1.al_1;
  }
  rcc() {
    var tmp = this.ac6_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('pImage');
    }
  }
  wc6(newPosArgument) {
    this.zc5_1 = newPosArgument;
    var error = false;
    var tmp;
    var containsArg = _get_newX__dauvtf(this);
    if (!(0 <= containsArg ? containsArg < 8 : false)) {
      tmp = true;
    } else {
      var containsArg_0 = _get_newY__dauvua(this);
      tmp = !(0 <= containsArg_0 ? containsArg_0 < 8 : false);
    }
    if (tmp)
      error = true;
    if (!this.yc5_1.equals(this.zc5_1)) {
      var pieceOnNewPos = findPiece(_get_newX__dauvtf(this), _get_newY__dauvua(this));
      var tmp_0 = pieceOnNewPos == null ? null : pieceOnNewPos.vc5_1;
      if (equals(tmp_0 == null ? null : new RGBA(tmp_0), new RGBA(this.vc5_1)))
        error = true;
      var currentSave = this.yc5_1;
      println('currentPos: ' + this.yc5_1.toString() + ', newPos: ' + this.zc5_1.toString() + ', error: ' + error + ', pieceOnNewPos: ' + toString_0(pieceOnNewPos));
      if (!error) {
        inCheck(GameState_getInstance().ubx_1);
        if (!GameState_getInstance().zbx_1 && (GameState_getInstance().ybx_1 || GameState_getInstance().xbx_1)) {
          println('in check     sent from line 116');
          if (this.scc()) {
            if (pieceOnNewPos == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              removePiece(pieceOnNewPos);
            }
          } else {
            this.yc5_1 = currentSave;
            movePiece(this, this.cc6(), this.dc6());
          }
          inCheck(GameState_getInstance().ubx_1);
          checkGameLegal();
        } else if (this.rc6(this.zc5_1) && !GameState_getInstance().ybx_1 && !GameState_getInstance().xbx_1) {
          if (this.scc()) {
            if (pieceOnNewPos == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              removePiece(pieceOnNewPos);
            }
          }
        } else {
          error = true;
        }
      }
      if (error) {
        this.yc5_1 = currentSave;
        movePiece(this, this.cc6(), this.dc6());
        var tmp3_safe_receiver = GameState_getInstance().oby_1;
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.ibx();
        }
        GameState_getInstance().oby_1 = null;
      }
      GameState_getInstance().fby_1 = null;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = GameState_getInstance().gby_1.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'de.fsaurenbach.sauronchess.client.Piece.clickListener.<anonymous>' call
        element.wad();
      }
      GameState_getInstance().gby_1.y2();
      println_0();
      println_0();
    } else {
      var tmp_1 = GameState_getInstance();
      // Inline function 'kotlin.apply' call
      var this_0 = ensureNotNull(findCell(this.cc6(), this.dc6()));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'de.fsaurenbach.sauronchess.client.Piece.clickListener.<anonymous>' call
      this_0.rbx();
      tmp_1.oby_1 = this_0;
      movePiece(this, this.cc6(), this.dc6());
    }
  }
  rc6(newPosOverride) {
    this.zc5_1 = newPosOverride;
    var tmp;
    switch (this.uc5_1.k3_1) {
      case 0:
      case 1:
        tmp = movePawn(this);
        break;
      case 2:
      case 3:
        tmp = moveRook(this);
        break;
      case 4:
      case 5:
        tmp = moveKnight(this);
        break;
      case 6:
      case 7:
        tmp = moveBishop(this);
        break;
      case 8:
      case 9:
        tmp = moveQueen(this);
        break;
      case 10:
      case 11:
        tmp = moveKing(this);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  hc7(newX, newY, receiver) {
    if (GameState_getInstance().zbx_1 && this.vc5_1 === Colors_getInstance().n3x_1 || (!GameState_getInstance().zbx_1 && this.vc5_1 === Colors_getInstance().m3x_1))
      return false;
    var oldX = this.cc6();
    var oldY = this.dc6();
    this.zc5_1 = new Pair(newX, newY);
    inCheck(GameState_getInstance().ubx_1);
    var pieceOnNewPos = findPiece(newX, newY);
    if (this.uc5_1.equals(PieceKind_WhitePawn_getInstance()) && newY === 0 || (this.uc5_1.equals(PieceKind_BlackPawn_getInstance()) && newY === 7)) {
      GameState_getInstance().aby_1 = true;
      if (UserSettings_instance.obx_1) {
        promoteTo(this, this.xc5_1 ? PieceKind_WhiteQueen_getInstance() : PieceKind_BlackQueen_getInstance());
        GameState_getInstance().aby_1 = false;
      } else {
        var promotionDialogue = addTo_0(PromotionDialogue.tcc(this.xc5_1), GameState_getInstance().v9v());
        var tmp = GameState_getInstance().v9v();
        launch(tmp, VOID, VOID, Piece$doMove$slambda_1(this, promotionDialogue));
      }
    }
    var tmp0_safe_receiver = GameState_getInstance().fby_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wad();
    }
    if (GameState_getInstance().vbx_1 && this.xc5_1 && this.cc6() === 4 && this.dc6() === 7 && GameState_getInstance().bby_1) {
      if (newX === 6 && newY === 7) {
        var rook = findPiece(7, 7);
        movePiece(ensureNotNull(rook), 5, 7);
        movePiece(this, newX, newY);
        GameState_getInstance().vbx_1 = false;
      } else if (newX === 2 && newY === 7) {
        var rook_0 = findPiece(0, 7);
        movePiece(ensureNotNull(rook_0), 3, 7);
        movePiece(this, newX, newY);
        GameState_getInstance().vbx_1 = false;
      }
    } else if (GameState_getInstance().wbx_1 && !this.xc5_1 && this.cc6() === 4 && this.dc6() === 0 && GameState_getInstance().bby_1) {
      if (newX === 6 && newY === 0) {
        var rook_1 = findPiece(7, 0);
        movePiece(ensureNotNull(rook_1), 5, 0);
        movePiece(this, newX, newY);
        GameState_getInstance().wbx_1 = false;
      } else if (newX === 2 && newY === 0) {
        var rook_2 = findPiece(0, 0);
        movePiece(ensureNotNull(rook_2), 3, 0);
        movePiece(this, newX, newY);
        GameState_getInstance().wbx_1 = false;
      }
    }
    movePiece(this, newX, newY);
    if (pieceOnNewPos == null)
      null;
    else {
      pieceOnNewPos.wc5_1 = true;
    }
    inCheck(GameState_getInstance().ubx_1);
    if (this.vc5_1 === Colors_getInstance().n3x_1 && GameState_getInstance().ybx_1 || (this.vc5_1 === Colors_getInstance().m3x_1 && GameState_getInstance().xbx_1)) {
      movePiece(this, oldX, oldY);
      println('King will (still) be in check after this move!');
      return false;
    }
    inCheck(GameState_getInstance().ubx_1);
    println('Doing move: ' + oldX + ', ' + oldY + ' ---> ' + this.cc6() + ', ' + this.dc6() + ', (still) inCheck: ' + inCheck(GameState_getInstance().ubx_1));
    if (!receiver && GameState_getInstance().nby_1) {
      var map = mutableMapOf([to('id', get_clientID()), to('cx', oldX.toString()), to('cy', oldY.toString()), to('newX', newX.toString()), to('newY', newY.toString())]);
      if (GameState_getInstance().bby_1) {
        // Inline function 'kotlin.collections.set' call
        var key = 'castling';
        map.f3(key, 'true');
      }
      map.h3(ensureNotNull(get_uniqueIdentifier()));
      println('SENDING :' + toJson(map));
      var tmp_0 = GameState_getInstance().v9v();
      launch(tmp_0, VOID, VOID, Piece$doMove$slambda_2(map));
    }
    if (GameState_getInstance().kby_1) {
      ensureNotNull(GameState_getInstance().iby_1).x1c_1.u1c();
      GameState_getInstance().kby_1 = false;
    } else {
      ensureNotNull(GameState_getInstance().iby_1).w1c_1.u1c();
      ensureNotNull(GameState_getInstance().iby_1).x1c_1.u1c();
    }
    this.yc5_1 = this.zc5_1;
    GameState_getInstance().bby_1 = false;
    if (pieceOnNewPos == null)
      null;
    else {
      pieceOnNewPos.wc5_1 = false;
    }
    GameState_getInstance().zbx_1 = !GameState_getInstance().zbx_1;
    if (pieceOnNewPos == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      removePiece(pieceOnNewPos);
    }
    if (!GameState_getInstance().bby_1) {
      switch (this.uc5_1.k3_1) {
        case 2:
        case 10:
          GameState_getInstance().vbx_1 = false;
          break;
        case 3:
        case 11:
          GameState_getInstance().wbx_1 = false;
          break;
        default:
          break;
      }
    }
    inCheck(GameState_getInstance().ubx_1);
    checkGameLegal();
    return true;
  }
  scc(newX, newY, receiver, $super) {
    newX = newX === VOID ? this.zc5_1.zk_1 : newX;
    newY = newY === VOID ? this.zc5_1.al_1 : newY;
    receiver = receiver === VOID ? false : receiver;
    return $super === VOID ? this.hc7(newX, newY, receiver) : $super.hc7.call(this, newX, newY, receiver);
  }
}
class checkGameLegal$slambda {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class checkGameLegal$slambda_0 {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class checkGameLegal$slambda_1 {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class PromotionDialogue extends Container {
  static tcc(isWhite) {
    var $this = this.g9y();
    $this.kcc_1 = isWhite;
    var tmp0_size = Size2D.j27(360, 80);
    var tmp1_fill = UserSettings_instance.nbx_1 ? ThemeColors_getInstance().mbx_1 : ThemeColors_getInstance().jbx_1;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    // Inline function 'korlibs.korge.view.roundRect' call
    var radius = new RectCorners(numberToDouble(10), numberToDouble(10), numberToDouble(10), numberToDouble(10));
    var fill = new RGBA(tmp1_fill);
    var stroke = new RGBA(Colors_getInstance().m3x_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.qbi(tmp0_size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    var bg = addTo(this_0, $this);
    centerXBetween($this, DisplayConfig_getInstance().zbw_1 / 2 | 0, DisplayConfig_getInstance().zbw_1 / 2 | 0);
    var tmp = $this;
    // Inline function 'korlibs.korge.view.image' call
    var texture = $this.kcc_1 ? ensureNotNull(Images_instance.ic6_1) : ensureNotNull(Images_instance.oc6_1);
    var anchor = Companion_getInstance_1().d25_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_1 = Image.kbf(texture, anchor);
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(this_1, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp.lcc_1 = centerYOn(alignLeftToLeftOf_0(this_2, bg), bg);
    var tmp_0 = $this;
    // Inline function 'korlibs.korge.view.image' call
    var texture_0 = $this.kcc_1 ? ensureNotNull(Images_instance.fc6_1) : ensureNotNull(Images_instance.lc6_1);
    var anchor_0 = Companion_getInstance_1().d25_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_3 = Image.kbf(texture_0, anchor_0);
    // Inline function 'kotlin.apply' call
    var this_4 = addTo(this_3, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp_0.mcc_1 = centerYOn(alignLeftToRightOf(this_4, $this.lcc_1), bg);
    var tmp_1 = $this;
    // Inline function 'korlibs.korge.view.image' call
    var texture_1 = $this.kcc_1 ? ensureNotNull(Images_instance.gc6_1) : ensureNotNull(Images_instance.mc6_1);
    var anchor_1 = Companion_getInstance_1().d25_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_5 = Image.kbf(texture_1, anchor_1);
    // Inline function 'kotlin.apply' call
    var this_6 = addTo(this_5, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp_1.ncc_1 = centerYOn(alignLeftToRightOf(this_6, $this.mcc_1), bg);
    var tmp_2 = $this;
    // Inline function 'korlibs.korge.view.image' call
    var texture_2 = $this.kcc_1 ? ensureNotNull(Images_instance.hc6_1) : ensureNotNull(Images_instance.nc6_1);
    var anchor_2 = Companion_getInstance_1().d25_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_7 = Image.kbf(texture_2, anchor_2);
    // Inline function 'kotlin.apply' call
    var this_8 = addTo(this_7, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    tmp_2.occ_1 = centerYOn(alignLeftToRightOf(this_8, $this.ncc_1), bg);
    return $this;
  }
  pcc($completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.uw();
    // Inline function 'de.fsaurenbach.sauronchess.client.PromotionDialogue.getChoice.<anonymous>' call
    // Inline function 'korlibs.korge.input.onDown' call
    var this_0 = this.lcc_1;
    var handler = PromotionDialogue$getChoice$lambda(this, cancellable);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = down$factory_0();
    var tmp1_safe_receiver = this_0 == null ? null : this_0.oab();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.f1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp = prop.get(tmp1_safe_receiver_0);
          tmp.x1w(PromotionDialogue$getChoice$lambda_0(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.input.onDown' call
    var this_1 = this.occ_1;
    var handler_0 = PromotionDialogue$getChoice$lambda_1(this, cancellable);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_0 = down$factory_1();
    var tmp1_safe_receiver_1 = this_1 == null ? null : this_1.oab();
    if (tmp1_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < tmp1_safe_receiver_1.d1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.f1(_unary__edvuaz_0);
        var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
        if (tmp1_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0 = prop_0.get(tmp1_safe_receiver_2);
          tmp_0.x1w(PromotionDialogue$getChoice$lambda_2(handler_0));
        }
      }
    }
    // Inline function 'korlibs.korge.input.onDown' call
    var this_2 = this.mcc_1;
    var handler_1 = PromotionDialogue$getChoice$lambda_3(this, cancellable);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_1 = down$factory_2();
    var tmp1_safe_receiver_3 = this_2 == null ? null : this_2.oab();
    if (tmp1_safe_receiver_3 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_1 = 0;
      while (n_1 < tmp1_safe_receiver_3.d1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_1 = n_1;
        n_1 = _unary__edvuaz_1 + 1 | 0;
        var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.f1(_unary__edvuaz_1);
        var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
        if (tmp1_safe_receiver_4 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_1 = prop_1.get(tmp1_safe_receiver_4);
          tmp_1.x1w(PromotionDialogue$getChoice$lambda_4(handler_1));
        }
      }
    }
    // Inline function 'korlibs.korge.input.onDown' call
    var this_3 = this.ncc_1;
    var handler_2 = PromotionDialogue$getChoice$lambda_5(this, cancellable);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_2 = down$factory_3();
    var tmp1_safe_receiver_5 = this_3 == null ? null : this_3.oab();
    if (tmp1_safe_receiver_5 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_2 = 0;
      while (n_2 < tmp1_safe_receiver_5.d1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_2 = n_2;
        n_2 = _unary__edvuaz_2 + 1 | 0;
        var tmp0_safe_receiver_2 = tmp1_safe_receiver_5.f1(_unary__edvuaz_2);
        var tmp1_safe_receiver_6 = tmp0_safe_receiver_2 == null ? null : get_mouse(tmp0_safe_receiver_2);
        if (tmp1_safe_receiver_6 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_2 = prop_2.get(tmp1_safe_receiver_6);
          tmp_2.x1w(PromotionDialogue$getChoice$lambda_6(handler_2));
        }
      }
    }
    return cancellable.gu();
  }
}
class AboutPage extends Container {
  static ack($outer, $box) {
    if ($box === VOID)
      $box = {};
    $box.zcj_1 = $outer;
    var $this = this.g9y(VOID, $box);
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.s2e(DisplayConfig_getInstance().cbx_1 / 2 * 1.7, DisplayConfig_getInstance().dbx_1 / 3 * 1.7);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    var radius = new RectCorners(numberToDouble(10), numberToDouble(10), numberToDouble(10), numberToDouble(10));
    var fill = new RGBA(Colors_getInstance().m3x_1);
    var stroke = new RGBA(Colors_getInstance().m3x_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.qbi(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'de.fsaurenbach.sauronchess.client.AboutPage.<anonymous>' call
    this_1.cay(UserSettings_instance.nbx_1 ? new RGBA(ThemeColors_getInstance().mbx_1) : new RGBA(ThemeColors_getInstance().jbx_1));
    var background = this_1;
    // Inline function 'korlibs.korge.view.roundRect' call
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_2();
    var height = background.x2i() - 30;
    var size_0 = Size2D.s2e(numberToDouble(500), numberToDouble(height));
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    var radius_0 = new RectCorners(numberToDouble(10), numberToDouble(10), numberToDouble(10), numberToDouble(10));
    var fill_0 = new RGBA(Colors_getInstance().i40_1);
    var stroke_0 = new RGBA(Colors_getInstance().m3x_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_2 = RoundRect.qbi(size_0, radius_0, fill_0, stroke_0, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_3 = addTo(this_2, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'de.fsaurenbach.sauronchess.client.AboutPage.<anonymous>' call
    centerOn(this_3, background);
    var bg = this_3;
    // Inline function 'korlibs.korge.view.image' call
    var texture = ensureNotNull(Images_instance.qc6_1);
    var anchor = Companion_getInstance_1().d25_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var this_4 = Image.kbf(texture, anchor);
    // Inline function 'kotlin.apply' call
    var this_5 = addTo(this_4, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.image.<anonymous>' call
    centerOn(scale(this_5, 0.5), bg);
    var exitButton = SettingsButton.bck($this.zcj_1, SettingsKind_About_getInstance());
    centerXOn(exitButton, bg);
    positionY(exitButton, bg.a69() + bg.x2i() / 4);
    // Inline function 'korlibs.korge.view.zIndex' call
    zIndex(exitButton, numberToDouble(33));
    addTo(exitButton, $this.zcj_1);
    return $this;
  }
}
class SettingsButton extends Container {
  static bck($outer, settingsKind, $box) {
    if ($box === VOID)
      $box = {};
    $box.ecf_1 = $outer;
    var $this = this.g9y(VOID, $box);
    $this.ccf_1 = settingsKind;
    $this.dcf_1 = Delegates_instance.wn();
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.j27(200, 50);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    var radius = new RectCorners(numberToDouble(10), numberToDouble(10), numberToDouble(10), numberToDouble(10));
    var fill = new RGBA(Colors_getInstance().p3y_1);
    var stroke = new RGBA(Colors_getInstance().m3x_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.qbi(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    _set_baseButton__px3tsk($this, centerYBetween(centerXOn(this_1, $this.ecf_1), $this.ecf_1.a69() + $this.ecf_1.x2i() / (1 + $this.ecf_1.nch_1 | 0) * $this.ecf_1.och_1, $this.ecf_1.a69() + $this.ecf_1.x2i() / (1 + $this.ecf_1.nch_1 | 0) * $this.ecf_1.och_1));
    switch ($this.ccf_1.k3_1) {
      case 0:
        // Inline function 'korlibs.korge.view.text' call

        var text = 'Dark mode';
        var color = Colors_getInstance().n3x_1;
        var font = get_DefaultTtfFontAsBitmap();
        var alignment = Companion_getInstance_3().s4l_1;
        var renderer = get_DefaultStringTextRenderer();
        var autoScaling = Companion_instance.dbp_1;
        // Inline function 'korlibs.korge.view.addTo' call

        var this_2 = Text.gbp(text, numberToDouble(30), color, font, alignment, renderer, autoScaling, null, null);
        // Inline function 'kotlin.apply' call

        var this_3 = addTo(this_2, $this);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korge.view.text.<anonymous>' call

        centerOn(this_3, _get_baseButton__auv8nc($this));
        _get_baseButton__auv8nc($this).bay(UserSettings_instance.nbx_1 ? Colors_getInstance().p3x_1 : Colors_getInstance().o3x_1);
        break;
      case 1:
        // Inline function 'korlibs.korge.view.text' call

        var color_0 = Colors_getInstance().n3x_1;
        var font_0 = get_DefaultTtfFontAsBitmap();
        var alignment_0 = Companion_getInstance_3().s4l_1;
        var renderer_0 = get_DefaultStringTextRenderer();
        var autoScaling_0 = Companion_instance.dbp_1;
        // Inline function 'korlibs.korge.view.addTo' call

        var this_4 = Text.gbp('About', numberToDouble(30), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
        // Inline function 'kotlin.apply' call

        var this_5 = addTo(this_4, $this);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korge.view.text.<anonymous>' call

        centerOn(this_5, _get_baseButton__auv8nc($this));
        break;
      case 3:
        // Inline function 'korlibs.korge.view.text' call

        var color_1 = Colors_getInstance().n3x_1;
        var font_1 = get_DefaultTtfFontAsBitmap();
        var alignment_1 = Companion_getInstance_3().s4l_1;
        var renderer_1 = get_DefaultStringTextRenderer();
        var autoScaling_1 = Companion_instance.dbp_1;
        // Inline function 'korlibs.korge.view.addTo' call

        var this_6 = Text.gbp('Exit', numberToDouble(30), color_1, font_1, alignment_1, renderer_1, autoScaling_1, null, null);
        // Inline function 'kotlin.apply' call

        var this_7 = addTo(this_6, $this);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korge.view.text.<anonymous>' call

        centerOn(this_7, _get_baseButton__auv8nc($this));
        break;
      case 2:
        // Inline function 'korlibs.korge.view.text' call

        var text_0 = 'Auto promote';
        var color_2 = Colors_getInstance().n3x_1;
        var font_2 = get_DefaultTtfFontAsBitmap();
        var alignment_2 = Companion_getInstance_3().s4l_1;
        var renderer_2 = get_DefaultStringTextRenderer();
        var autoScaling_2 = Companion_instance.dbp_1;
        // Inline function 'korlibs.korge.view.addTo' call

        var this_8 = Text.gbp(text_0, numberToDouble(30), color_2, font_2, alignment_2, renderer_2, autoScaling_2, null, null);
        // Inline function 'kotlin.apply' call

        var this_9 = addTo(this_8, $this);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.korge.view.text.<anonymous>' call

        centerOn(this_9, _get_baseButton__auv8nc($this));
        _get_baseButton__auv8nc($this).bay(UserSettings_instance.obx_1 ? Colors_getInstance().p3x_1 : Colors_getInstance().o3x_1);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    // Inline function 'korlibs.korge.input.onClick' call
    var handler = Settings$SettingsButton$lambda($this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory_1();
    var tmp1_safe_receiver = $this == null ? null : $this.oab();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.d1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.f1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp = prop.get(tmp1_safe_receiver_0);
          tmp.x1w(Settings$SettingsButton$lambda_0(handler));
        }
      }
    }
    var _unary__edvuaz_0 = $this.ecf_1.och_1;
    $this.ecf_1.och_1 = _unary__edvuaz_0 + 1 | 0;
    return $this;
  }
}
class SettingsKind extends Enum {}
class Settings extends Container {
  static cck() {
    var $this = this.g9y();
    $this.nch_1 = 4;
    $this.och_1 = 1;
    $this.pch_1 = Delegates_instance.wn();
    // Inline function 'korlibs.korge.view.roundRect' call
    var size = Size2D.s2e(DisplayConfig_getInstance().cbx_1 / 1.5, DisplayConfig_getInstance().dbx_1 / 1.5);
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    var radius = new RectCorners(numberToDouble(15), numberToDouble(15), numberToDouble(15), numberToDouble(15));
    var fill = new RGBA(Colors_getInstance().m3x_1);
    var stroke = new RGBA(Colors_getInstance().m3x_1);
    // Inline function 'korlibs.korge.view.addTo' call
    var this_0 = RoundRect.qbi(size, radius, fill, stroke, 0.0, true);
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(this_0, $this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    $this.dck(this_1);
    $this.qch().bay(UserSettings_instance.nbx_1 ? ThemeColors_getInstance().mbx_1 : ThemeColors_getInstance().jbx_1);
    addTo(SettingsButton.bck($this, SettingsKind_DarkMode_getInstance()), $this);
    addTo(SettingsButton.bck($this, SettingsKind_About_getInstance()), $this);
    addTo(SettingsButton.bck($this, SettingsKind_AutoPromote_getInstance()), $this);
    addTo(SettingsButton.bck($this, SettingsKind_Exit_getInstance()), $this);
    return $this;
  }
  dck(_set____db54di) {
    return this.pch_1.bo(this, background$factory(), _set____db54di);
  }
  qch() {
    return this.pch_1.zn(this, background$factory_0());
  }
}
class Slot extends Container {
  static ocm(roundRect, number) {
    var $this = this.g9y();
    $this.mcm_1 = roundRect;
    $this.ncm_1 = number;
    addTo_0($this.mcm_1, $this);
    return $this;
  }
}
class Wizard$updateOnline$slambda {
  constructor(this$0) {
    this.pcm_1 = this$0;
  }
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Wizard$updateSlots$slambda {
  constructor(this$0) {
    this.qcm_1 = this$0;
  }
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Wizard$changeScene$slambda {
  h1b($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this, $this$launch), $completion);
  }
  pd(p1, $completion) {
    return this.h1b((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Wizard extends Scene {
  constructor() {
    super();
    this.bcn_1 = 4;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ccn_1 = ArrayList.i1();
    this.dcn_1 = true;
    this.ecn_1 = true;
    this.hcn_1 = Size2D.j27(100, 100);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.invoke' call
    Companion_getInstance_0();
    tmp_0.icn_1 = new RectCorners(numberToDouble(10), numberToDouble(10), numberToDouble(10), numberToDouble(10));
  }
  wa0(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl_0.bind(VOID, _this__u8e3s4, this), $completion);
  }
}
//endregion
function cell(_this__u8e3s4, isWhite, cx, cy, text) {
  return addTo(Cell.ybw(isWhite, cx, cy, text), _this__u8e3s4);
}
function moveCell($this, newX, newY) {
  $this.d4q(Vector2D.l28(newX * DisplayConfig_getInstance().fbx() + DisplayConfig_getInstance().ebx_1, newY * DisplayConfig_getInstance().gbx() + DisplayConfig_getInstance().hbx()));
}
function findCell(cx, cy) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = GameState_getInstance().tbx_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'de.fsaurenbach.sauronchess.client.findCell.<anonymous>' call
      if (element.vbw_1 === cx && element.wbw_1 === cy) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function reloadCells() {
  var tmp0_iterator = GameState_getInstance().tbx_1.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'de.fsaurenbach.sauronchess.client.reloadCells.<anonymous>' call
    element.ibx();
  }
  return Unit_instance;
}
function ChessClockContainer$Timer$lambda($counter, $timer) {
  return function ($this$addFixedUpdater) {
    $counter.hbp(_Duration___get_inWholeSeconds__impl__hpy7b3($timer.r1c_1).toString());
    return Unit_instance;
  };
}
function initializeBoard(chessboard) {
  var d = 0;
  var inductionVariable = 0;
  if (inductionVariable < 8)
    do {
      var cx = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < 8)
        do {
          var cy = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var text = toString(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(97), cx)) + (8 - cy | 0);
          GameState_getInstance().tbx_1.h(cell(chessboard, get_isEven(d), cx, cy, text));
          d = d + 1 | 0;
        }
         while (inductionVariable_0 < 8);
      d = d + 1 | 0;
    }
     while (inductionVariable < 8);
}
function findPiece(x, y) {
  // Inline function 'kotlin.collections.find' call
  var this_0 = GameState_getInstance().ubx_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'de.fsaurenbach.sauronchess.client.findPiece.<anonymous>' call
      if (element.cc6() === x && element.dc6() === y) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
}
function movePiece(piece, newX, newY) {
  var tmp0_safe_receiver = findCell(newX, newY);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'de.fsaurenbach.sauronchess.client.movePiece.<anonymous>' call
    centerOn(piece, tmp0_safe_receiver);
  }
  piece.yc5_1 = new Pair(newX, newY);
}
function removePiece(piece) {
  GameState_getInstance().ubx_1.x2(piece);
  piece.wad();
}
function addAllPieces(_this__u8e3s4) {
  var inductionVariable = 0;
  if (inductionVariable < 8)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      piece(_this__u8e3s4, PieceKind_WhitePawn_getInstance(), Colors_getInstance().m3x_1, i, 6, VOID, true);
    }
     while (inductionVariable < 8);
  piece(_this__u8e3s4, PieceKind_WhiteRook_getInstance(), Colors_getInstance().m3x_1, 0, 7, VOID, true);
  piece(_this__u8e3s4, PieceKind_WhiteRook_getInstance(), Colors_getInstance().m3x_1, 7, 7, VOID, true);
  piece(_this__u8e3s4, PieceKind_WhiteKnight_getInstance(), Colors_getInstance().m3x_1, 1, 7, VOID, true);
  piece(_this__u8e3s4, PieceKind_WhiteKnight_getInstance(), Colors_getInstance().m3x_1, 6, 7, VOID, true);
  piece(_this__u8e3s4, PieceKind_WhiteBishop_getInstance(), Colors_getInstance().m3x_1, 2, 7, VOID, true);
  piece(_this__u8e3s4, PieceKind_WhiteBishop_getInstance(), Colors_getInstance().m3x_1, 5, 7, VOID, true);
  piece(_this__u8e3s4, PieceKind_WhiteQueen_getInstance(), Colors_getInstance().m3x_1, 3, 7, VOID, true);
  piece(_this__u8e3s4, PieceKind_WhiteKing_getInstance(), Colors_getInstance().m3x_1, 4, 7, VOID, true);
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < 8)
    do {
      var i_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      piece(_this__u8e3s4, PieceKind_BlackPawn_getInstance(), Colors_getInstance().n3x_1, i_0, 1, VOID, false);
    }
     while (inductionVariable_0 < 8);
  piece(_this__u8e3s4, PieceKind_BlackRook_getInstance(), Colors_getInstance().n3x_1, 0, 0, VOID, false);
  piece(_this__u8e3s4, PieceKind_BlackRook_getInstance(), Colors_getInstance().n3x_1, 7, 0, VOID, false);
  piece(_this__u8e3s4, PieceKind_BlackKnight_getInstance(), Colors_getInstance().n3x_1, 1, 0, VOID, false);
  piece(_this__u8e3s4, PieceKind_BlackKnight_getInstance(), Colors_getInstance().n3x_1, 6, 0, VOID, false);
  piece(_this__u8e3s4, PieceKind_BlackBishop_getInstance(), Colors_getInstance().n3x_1, 2, 0, VOID, false);
  piece(_this__u8e3s4, PieceKind_BlackBishop_getInstance(), Colors_getInstance().n3x_1, 5, 0, VOID, false);
  piece(_this__u8e3s4, PieceKind_BlackQueen_getInstance(), Colors_getInstance().n3x_1, 3, 0, VOID, false);
  piece(_this__u8e3s4, PieceKind_BlackKing_getInstance(), Colors_getInstance().n3x_1, 4, 0, VOID, false);
  var _iterator__ex2g4s = GameState_getInstance().ubx_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var piece_0 = _iterator__ex2g4s.c1();
    movePiece(piece_0, piece_0.cc6(), piece_0.dc6());
  }
}
function *_generator_reloadPictures__yt7ryy($completion) {
  var tmp = Images_instance;
  var tmp_0 = readSVG(get_resourcesVfs().xh('wikipedia/white_pieces/Chess_plt45.svg'), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.ec6_1 = render(scaled(tmp_0, 2.2, 2.0));
  var tmp_1 = Images_instance;
  var tmp_2 = readSVG(get_resourcesVfs().xh('wikipedia/white_pieces/Chess_rlt45.svg'), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  tmp_1.fc6_1 = render(scaled(tmp_2, 2.0, 2.0));
  var tmp_3 = Images_instance;
  var tmp_4 = readSVG(get_resourcesVfs().xh('wikipedia/white_pieces/Chess_nlt45.svg'), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  tmp_3.gc6_1 = render(scaled(tmp_4, 2.0, 2.0));
  var tmp_5 = Images_instance;
  var tmp_6 = readSVG(get_resourcesVfs().xh('wikipedia/white_pieces/Chess_blt45.svg'), $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  tmp_5.hc6_1 = render(scaled(tmp_6, 2.0, 2.0));
  var tmp_7 = Images_instance;
  var tmp_8 = readSVG(get_resourcesVfs().xh('wikipedia/white_pieces/Chess_qlt45.svg'), $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  tmp_7.ic6_1 = render(scaled(tmp_8, 2.0, 2.0));
  var tmp_9 = Images_instance;
  var tmp_10 = readSVG(get_resourcesVfs().xh('wikipedia/white_pieces/Chess_klt45.svg'), $completion);
  if (tmp_10 === get_COROUTINE_SUSPENDED())
    tmp_10 = yield tmp_10;
  tmp_9.jc6_1 = render(scaled(tmp_10, 2.0, 2.0));
  var tmp_11 = Images_instance;
  var tmp_12 = readSVG(get_resourcesVfs().xh('wikipedia/black_pieces/Chess_pdt45.svg'), $completion);
  if (tmp_12 === get_COROUTINE_SUSPENDED())
    tmp_12 = yield tmp_12;
  tmp_11.kc6_1 = render(scaled(tmp_12, 2.2, 2.0));
  var tmp_13 = Images_instance;
  var tmp_14 = readSVG(get_resourcesVfs().xh('wikipedia/black_pieces/Chess_rdt45.svg'), $completion);
  if (tmp_14 === get_COROUTINE_SUSPENDED())
    tmp_14 = yield tmp_14;
  tmp_13.lc6_1 = render(scaled(tmp_14, 2.0, 2.0));
  var tmp_15 = Images_instance;
  var tmp_16 = readSVG(get_resourcesVfs().xh('wikipedia/black_pieces/Chess_ndt45.svg'), $completion);
  if (tmp_16 === get_COROUTINE_SUSPENDED())
    tmp_16 = yield tmp_16;
  tmp_15.mc6_1 = render(scaled(tmp_16, 2.0, 2.0));
  var tmp_17 = Images_instance;
  var tmp_18 = readSVG(get_resourcesVfs().xh('wikipedia/black_pieces/Chess_bdt45.svg'), $completion);
  if (tmp_18 === get_COROUTINE_SUSPENDED())
    tmp_18 = yield tmp_18;
  tmp_17.nc6_1 = render(scaled(tmp_18, 2.0, 2.0));
  var tmp_19 = Images_instance;
  var tmp_20 = readSVG(get_resourcesVfs().xh('wikipedia/black_pieces/Chess_qdt45.svg'), $completion);
  if (tmp_20 === get_COROUTINE_SUSPENDED())
    tmp_20 = yield tmp_20;
  tmp_19.oc6_1 = render(scaled(tmp_20, 2.0, 2.0));
  var tmp_21 = Images_instance;
  var tmp_22 = readSVG(get_resourcesVfs().xh('wikipedia/black_pieces/Chess_kdt45.svg'), $completion);
  if (tmp_22 === get_COROUTINE_SUSPENDED())
    tmp_22 = yield tmp_22;
  tmp_21.pc6_1 = render(scaled(tmp_22, 2.0, 2.0));
  var tmp_23 = Images_instance;
  var tmp_24 = readBitmap(get_resourcesVfs().xh('credits.png'), VOID, $completion);
  if (tmp_24 === get_COROUTINE_SUSPENDED())
    tmp_24 = yield tmp_24;
  tmp_23.qc6_1 = tmp_24;
  return Unit_instance;
}
function reloadPictures($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_reloadPictures__yt7ryy.bind(VOID), $completion);
}
function simulateMove(oldPos, newPos, piece, calledFromKing) {
  calledFromKing = calledFromKing === VOID ? false : calledFromKing;
  if (!calledFromKing) {
    if (!piece.rc6(newPos)) {
      return false;
    }
  }
  inCheck(GameState_getInstance().ubx_1, calledFromKing);
  var pieceOnNewPos = findPiece(newPos.zk_1, newPos.al_1);
  var tmp = pieceOnNewPos == null ? null : pieceOnNewPos.vc5_1;
  if (equals(new RGBA(piece.vc5_1), tmp == null ? null : new RGBA(tmp)))
    return false;
  if (GameState_getInstance().zbx_1 && piece.vc5_1 === Colors_getInstance().n3x_1)
    return false;
  if (!GameState_getInstance().zbx_1 && piece.vc5_1 === Colors_getInstance().m3x_1)
    return false;
  movePiece(piece, newPos.zk_1, newPos.al_1);
  if (pieceOnNewPos == null)
    null;
  else {
    pieceOnNewPos.wc5_1 = true;
  }
  if (piece.vc5_1 === Colors_getInstance().m3x_1 && GameState_getInstance().ybx_1 || (piece.vc5_1 === Colors_getInstance().n3x_1 && GameState_getInstance().xbx_1)) {
    movePiece(piece, oldPos.zk_1, oldPos.al_1);
    return false;
  }
  var stillInCheck = inCheck(GameState_getInstance().ubx_1, calledFromKing);
  movePiece(piece, oldPos.zk_1, oldPos.al_1);
  if (pieceOnNewPos == null)
    null;
  else {
    pieceOnNewPos.wc5_1 = false;
  }
  return !stillInCheck;
}
function centerYBetween_0(_this__u8e3s4, y1, y2) {
  _this__u8e3s4.cac((y2 + y1 - _this__u8e3s4.xac()) / 2);
  return _this__u8e3s4;
}
function addTo_0(_this__u8e3s4, parent) {
  parent.f9y(_this__u8e3s4);
  return _this__u8e3s4;
}
function addTo_1(_this__u8e3s4, parent) {
  parent.h(_this__u8e3s4);
}
function set_wsClient(_set____db54di) {
  _init_properties_Main_kt__xi25uv();
  wsClient = _set____db54di;
}
function get_wsClient() {
  _init_properties_Main_kt__xi25uv();
  return wsClient;
}
var wsClient;
function get_clientID() {
  _init_properties_Main_kt__xi25uv();
  return clientID;
}
var clientID;
function set_uniqueIdentifier(_set____db54di) {
  _init_properties_Main_kt__xi25uv();
  uniqueIdentifier = _set____db54di;
}
function get_uniqueIdentifier() {
  _init_properties_Main_kt__xi25uv();
  return uniqueIdentifier;
}
var uniqueIdentifier;
var GameState_instance;
function GameState_getInstance() {
  if (GameState_instance === VOID)
    new GameState();
  return GameState_instance;
}
var Images_instance;
function Images_getInstance() {
  return Images_instance;
}
var DisplayConfig_instance;
function DisplayConfig_getInstance() {
  if (DisplayConfig_instance === VOID)
    new DisplayConfig();
  return DisplayConfig_instance;
}
var ThemeColors_instance;
function ThemeColors_getInstance() {
  if (ThemeColors_instance === VOID)
    new ThemeColors();
  return ThemeColors_instance;
}
var UserSettings_instance;
function UserSettings_getInstance() {
  return UserSettings_instance;
}
function get_serverPort() {
  _init_properties_Main_kt__xi25uv();
  return UserSettings_instance.pbx_1 ? 9999 : 443;
}
function get_serverAddress() {
  _init_properties_Main_kt__xi25uv();
  return UserSettings_instance.pbx_1 ? '127.0.0.1' : 'chessapi.fsrb.de';
}
function get_protocolSecurity() {
  _init_properties_Main_kt__xi25uv();
  return UserSettings_instance.pbx_1 ? '' : 's';
}
function main($completion) {
  var tmp = Size2D.j27(DisplayConfig_getInstance().zbw_1, DisplayConfig_getInstance().abx_1);
  var tmp_0 = Colors_getInstance().e4d('#4b3621');
  var tmp_1 = Quality_QUALITY_getInstance();
  return Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = sendGameEnd('resign', $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$launch, $completion) {
  var tmp = ensureNotNull(get_wsClient()).w33(toJson(ensureNotNull(get_uniqueIdentifier())), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = webSockerListener($this.vc6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = DisplayConfig_getInstance().cbx_1 + 18;
  var height = DisplayConfig_getInstance().dbx_1 + 18;
  var color = ThemeColors_getInstance().kbx_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.zbk(Size2D.s2e(width, height), color);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  centerOnStage(this_1);
  // Inline function 'korlibs.korge.view.solidRect' call
  var width_0 = DisplayConfig_getInstance().cbx_1 + 10;
  var height_0 = DisplayConfig_getInstance().dbx_1 + 10;
  var color_0 = ThemeColors_getInstance().jbx_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = SolidRect.zbk(Size2D.s2e(width_0, height_0), color_0);
  // Inline function 'kotlin.apply' call
  var this_3 = addTo(this_2, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  centerOnStage(this_3);
  // Inline function 'korlibs.korge.view.solidRect' call
  var width_1 = DisplayConfig_getInstance().cbx_1 + 1;
  var height_1 = DisplayConfig_getInstance().dbx_1 + 1;
  var color_1 = Colors_getInstance().n3x_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = SolidRect.zbk(Size2D.s2e(width_1, height_1), color_1);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  centerOnStage(this_5);
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_6 = Container.g9y(false);
  // Inline function 'kotlin.apply' call
  var this_7 = addTo(this_6, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'de.fsaurenbach.sauronchess.client.GameScene.sceneMain.<anonymous>' call
  position(this_7, DisplayConfig_getInstance().ebx_1, DisplayConfig_getInstance().hbx());
  this_7.yac(DisplayConfig_getInstance().cbx_1);
  this_7.zac(DisplayConfig_getInstance().cbx_1);
  var chessboard = this_7;
  // Inline function 'korlibs.korge.view.image' call
  var tmp = readSVG(get_resourcesVfs().xh('settings.svg'), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var texture = render(scaled(tmp, 0.5));
  var anchor = Companion_getInstance_1().d25_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_8 = Image.kbf(texture, anchor);
  // Inline function 'kotlin.apply' call
  var this_9 = addTo(this_8, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'de.fsaurenbach.sauronchess.client.GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.view.zIndex' call
  zIndex(this_9, numberToDouble(3));
  // Inline function 'korlibs.korge.view.position' call
  var x = DisplayConfig_getInstance().zbw_1 * 0.8;
  xy(this_9, numberToDouble(x), numberToDouble(26));
  // Inline function 'korlibs.korge.input.onClick' call
  var handler = GameScene$sceneMain$lambda;
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory();
  var tmp1_safe_receiver = this_9 == null ? null : this_9.oab();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.d1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.f1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0 = prop.get(tmp1_safe_receiver_0);
        tmp_0.x1w(GameScene$sceneMain$lambda_0(handler));
      }
    }
  }
  var settingsButton = this_9;
  // Inline function 'korlibs.korge.view.positionY' call
  // Inline function 'korlibs.korge.view.image' call
  var tmp_1 = readSVG(get_resourcesVfs().xh('resign.svg'), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var texture_0 = render(scaled(tmp_1, 0.5));
  var anchor_0 = Companion_getInstance_1().d25_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_10 = Image.kbf(texture_0, anchor_0);
  // Inline function 'kotlin.apply' call
  var this_11 = addTo(this_10, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'de.fsaurenbach.sauronchess.client.GameScene.sceneMain.<anonymous>' call
  alignRightToLeftOf(this_11, settingsButton);
  // Inline function 'korlibs.korge.view.zIndex' call
  zIndex(this_11, numberToDouble(3));
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_0 = GameScene$sceneMain$lambda_1($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = click$factory_0();
  var tmp1_safe_receiver_1 = this_11 == null ? null : this_11.oab();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.d1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.f1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2 = prop_0.get(tmp1_safe_receiver_2);
        tmp_2.x1w(GameScene$sceneMain$lambda_2(handler_0));
      }
    }
  }
  positionY(this_11, numberToDouble(26));
  println('initializing clock');
  var tmp_3 = GameState_getInstance();
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp_4 = toDuration(90, DurationUnit_SECONDS_getInstance());
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$34 = toDuration(90, DurationUnit_SECONDS_getInstance());
  tmp_3.iby_1 = new ChessClock(tmp_4, tmp$ret$34, timesUp());
  GameState_getInstance().jby_1 = addTo_0(ChessClockContainer.lc3(), _this__u8e3s4);
  centerXOnStage(ensureNotNull(GameState_getInstance().jby_1));
  if (GameState_getInstance().nby_1) {
    var tmp_5 = WebSocketClient('ws' + get_protocolSecurity() + '://' + get_serverAddress() + ':' + get_serverPort(), VOID, VOID, VOID, VOID, VOID, VOID, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    set_wsClient(tmp_5);
    println('Opened socket');
    set_uniqueIdentifier(mapOf([to('id', get_clientID()), to('color', GameState_getInstance().lby_1.toString()), to('slot', GameState_getInstance().mby_1.toString())]));
    println('sending: ' + toJson(ensureNotNull(get_uniqueIdentifier())));
    launch($this, VOID, VOID, GameScene$sceneMain$slambda_0());
    var tmp_6 = ensureNotNull(get_wsClient()).s33_1;
    tmp_6.y1w(GameScene$sceneMain$lambda_3($this));
  }
  // Inline function 'korlibs.korge.input.onDown' call
  var handler_1 = GameScene$sceneMain$lambda_4;
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = down$factory();
  var tmp1_safe_receiver_3 = _this__u8e3s4 == null ? null : _this__u8e3s4.oab();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.d1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.f1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_7 = prop_1.get(tmp1_safe_receiver_4);
        tmp_7.x1w(GameScene$sceneMain$lambda_5(handler_1));
      }
    }
  }
  centerYBetween_0(settingsButton, DisplayConfig_getInstance().hbx(), 0.0);
  initializeBoard(chessboard);
  var tmp_8 = reloadPictures($completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  addAllPieces(chessboard);
  return Unit_instance;
}
function GameScene$sceneMain$lambda(it) {
  if (!GameState_getInstance().cby_1) {
    showSettings();
  }
  return Unit_instance;
}
function GameScene$sceneMain$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda$slambda_1() {
  var i = new GameScene$sceneMain$lambda$slambda();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda_1(this$0) {
  return function (it) {
    launch(this$0, VOID, VOID, GameScene$sceneMain$lambda$slambda_1());
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$sceneMain$slambda_0() {
  var i = new GameScene$sceneMain$slambda();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda$slambda_2($it) {
  var i = new GameScene$sceneMain$lambda$slambda_0($it);
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda_3(this$0) {
  return function (it) {
    launch(this$0, VOID, VOID, GameScene$sceneMain$lambda$slambda_2(it));
    return Unit_instance;
  };
}
function GameScene$sceneMain$lambda_4(it) {
  if (!(GameState_getInstance().oby_1 == null)) {
    println('Resetting cell ' + toString_0(GameState_getInstance().oby_1));
    var downPosition = new Pair(numberToInt(it.z9u().c26_1 - DisplayConfig_getInstance().ebx_1) / numberToInt(DisplayConfig_getInstance().fbx()) | 0, numberToInt(it.z9u().d26_1 - DisplayConfig_getInstance().hbx()) / numberToInt(DisplayConfig_getInstance().gbx()) | 0);
    var cell = findCell(downPosition.zk_1, downPosition.al_1);
    if (!(cell == null)) {
      var piece = findPiece(ensureNotNull(GameState_getInstance().oby_1).vbw_1, ensureNotNull(GameState_getInstance().oby_1).wbw_1);
      if (!(piece == null)) {
        println('starting clickListener');
        piece.wc6(downPosition);
      }
    }
    var tmp0_safe_receiver = GameState_getInstance().oby_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ibx();
    }
    GameState_getInstance().oby_1 = null;
  }
  return Unit_instance;
}
function GameScene$sceneMain$lambda_5($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function *_generator_webSockerListener__2eveg5(message, $completion) {
  println('INCOMING MESSAGE: ' + message);
  var map;
  try {
    var tmp = fromJson(message);
    map = (!(tmp == null) ? isInterface(tmp, KtMap) : false) ? tmp : THROW_CCE();
  } catch ($p) {
    if ($p instanceof Exception) {
      var e = $p;
      return Unit_instance;
    } else {
      throw $p;
    }
  }
  if (map.b3('gameOver')) {
    var tmp_0 = handleGameEnd(toString_0(map.d3('reason')), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return Unit_instance;
  }
  if (map.b3('whiteTimeLeft')) {
    var whiteTime = toDuration(toDouble(toString_1(ensureNotNull(map.d3('whiteTimeLeft')))), DurationUnit_SECONDS_getInstance());
    var blackTime = toDuration(toDouble(toString_1(ensureNotNull(map.d3('blackTimeLeft')))), DurationUnit_SECONDS_getInstance());
    println('white: ' + Duration__toString_impl_8d916b(whiteTime));
    println('black: ' + Duration__toString_impl_8d916b(blackTime));
    ensureNotNull(GameState_getInstance().iby_1).w1c_1.v1c(whiteTime);
    ensureNotNull(GameState_getInstance().iby_1).x1c_1.v1c(blackTime);
  }
  if (map.b3('timeSync')) {
    return Unit_instance;
  }
  if (map.b3('castling'))
    GameState_getInstance().bby_1 = true;
  println('cx: ' + map.d3('cx') + ', cy: ' + map.d3('cy') + ', newX, ' + map.d3('newX') + ', newY: ' + map.d3('newY'));
  if (map.d3('cx') == null || map.d3('cy') == null || map.d3('newX') == null || map.d3('newY') == null)
    return Unit_instance;
  var piece = findPiece(toInt(ensureNotNull(map.d3('cx'))), toInt(ensureNotNull(map.d3('cy'))));
  println('cx: ' + toString_0(piece == null ? null : piece.yc5_1));
  if (piece == null)
    null;
  else
    piece.hc7(toInt(ensureNotNull(map.d3('newX'))), toInt(ensureNotNull(map.d3('newY'))), true);
  return Unit_instance;
}
function webSockerListener(message, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_webSockerListener__2eveg5.bind(VOID, message), $completion);
}
function inCheck(piecesList, fromCastling) {
  fromCastling = fromCastling === VOID ? false : fromCastling;
  _init_properties_Main_kt__xi25uv();
  GameState_getInstance().xbx_1 = false;
  GameState_getInstance().ybx_1 = false;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator = piecesList.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'de.fsaurenbach.sauronchess.client.inCheck.<anonymous>' call
      if (element.uc5_1.equals(PieceKind_WhiteKing_getInstance())) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp$ret$2 = tmp$ret$1;
  var whiteKingPosition = ensureNotNull(tmp$ret$2).yc5_1;
  // Inline function 'kotlin.collections.find' call
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var tmp0_iterator_0 = piecesList.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'de.fsaurenbach.sauronchess.client.inCheck.<anonymous>' call
      if (element_0.uc5_1.equals(PieceKind_BlackKing_getInstance())) {
        tmp$ret$4 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$4 = null;
  }
  var tmp$ret$5 = tmp$ret$4;
  var blackKingPosition = ensureNotNull(tmp$ret$5).yc5_1;
  var _iterator__ex2g4s = piecesList.a1();
  while (_iterator__ex2g4s.b1()) {
    var enemyPiece = _iterator__ex2g4s.c1();
    if (enemyPiece.vc5_1 === Colors_getInstance().n3x_1 && !enemyPiece.wc5_1) {
      if (!GameState_getInstance().zbx_1 && !fromCastling)
        return false;
      if (enemyPiece.rc6(whiteKingPosition)) {
        GameState_getInstance().xbx_1 = true;
        return true;
      }
    } else if (enemyPiece.vc5_1 === Colors_getInstance().m3x_1 && !enemyPiece.wc5_1) {
      if (GameState_getInstance().zbx_1 && !fromCastling)
        return false;
      if (enemyPiece.rc6(blackKingPosition)) {
        GameState_getInstance().ybx_1 = true;
        return true;
      }
    }
  }
  return false;
}
function *_generator_sendGameEnd__r0zyq5(reason, $completion) {
  if (GameState_getInstance().nby_1) {
    var map = toMutableMap(ensureNotNull(get_uniqueIdentifier()));
    // Inline function 'kotlin.collections.set' call
    var key = 'gameOver';
    map.f3(key, 'true');
    // Inline function 'kotlin.collections.set' call
    map.f3('reason', reason);
    var tmp = GameState_getInstance().v9v();
    launch(tmp, VOID, VOID, sendGameEnd$slambda_0(map));
  }
  println('reasonHere: ' + reason);
  var tmp_0 = handleGameEnd(reason, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function sendGameEnd(reason, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sendGameEnd__r0zyq5.bind(VOID, reason), $completion);
}
function *_generator_handleGameEnd__wglral(reason, $completion) {
  // Inline function 'korlibs.korge.view.text' call
  var this_0 = GameState_getInstance().v9v();
  var text = 'GAME END\nBecause of: \n' + reason;
  var color = Colors_getInstance().o3x_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_3().s4l_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.dbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Text.gbp(text, numberToDouble(50), color, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  var text_0 = addTo(this_1, this_0);
  centerOnStage(text_0);
  var tmp = delay(new Long(4000, 0), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = GameState_getInstance().v9v();
  var tmp_1 = launch(tmp_0, VOID, VOID, handleGameEnd$slambda_0());
  tmp_1.et(handleGameEnd$lambda(text_0));
  return Unit_instance;
}
function handleGameEnd(reason, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_handleGameEnd__wglral.bind(VOID, reason), $completion);
}
function timesUp() {
  _init_properties_Main_kt__xi25uv();
  return timesUp$lambda;
}
function *_generator_invoke__zhh2q8_2($this, $this$Korge, $completion) {
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_5()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_2().u2g_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp = views($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var views_0 = tmp;
  var width = size.bl();
  var height = size.cl();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_0 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
    var tmp1_elvis_lhs = base == null ? null : base.w2i();
    rwidth = tmp1_elvis_lhs == null ? views_0.t9h_1.w2i() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.x2i();
    rheight = tmp3_elvis_lhs == null ? views_0.t9h_1.x2i() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.u9n(views_0, defaultTransition, name, Size2D.s2e(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, $this$Korge);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'de.fsaurenbach.sauronchess.client.main.<anonymous>.<anonymous>' call
  GameState_getInstance().sc6(this_1);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_1.p9n_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(Wizard);
  var injects_0 = injects.slice();
  var sceneInjector = this_1.o9n_1.j9g_1.f62().d62(getKClass(SceneContainer), this_1).d62(getKClass(Resources), new Resources(this_1.ds(), this_1.o9n_1.q9o().y33_1, this_1.o9n_1.q9o()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_1 = getKClassFromExpression(inject);
    sceneInjector.d62(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
  }
  // Inline function 'de.fsaurenbach.sauronchess.client.main.<anonymous>.<anonymous>.<anonymous>' call
  var newScene = new Wizard();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_2 = Companion_getInstance().xa1_1;
  var level = Level_INFO_getInstance();
  var tmp_2;
  if (this_2.k2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString_1(clazz) + ' ... ' + toString_1(newScene);
    this_2.l2t(level, tmp$ret$8);
    tmp_2 = Unit_instance;
  }
  if (true) {
    newScene.o62(sceneInjector);
    var tmp_3 = getKClassFromExpression(newScene);
    var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
    this_1.o9n_1.j9g_1.h62(tmp_4, main$slambda$lambda_0(sceneInjector));
  }
  var tmp_5 = this_1.za1(newScene, time, transition, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'de.fsaurenbach.sauronchess.client.main.<anonymous>.<anonymous>.<anonymous>' call
    return new Wizard();
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.c9d($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  var tmp0_safe_receiver = get_wsClient();
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = tmp0_safe_receiver.w33(toJson($this.ic7_1), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function sendGameEnd$slambda_0($map) {
  var i = new sendGameEnd$slambda($map);
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $this$launch, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = GameState_getInstance().v9v();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.p9n_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(Wizard);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.o9n_1.j9g_1.f62().d62(getKClass(SceneContainer), this_0).d62(getKClass(Resources), new Resources(this_0.ds(), this_0.o9n_1.q9o().y33_1, this_0.o9n_1.q9o()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.d62(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'de.fsaurenbach.sauronchess.client.handleGameEnd.<anonymous>.<anonymous>' call
  var newScene = new Wizard();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance().xa1_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.k2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString_1(clazz) + ' ... ' + toString_1(newScene);
    this_1.l2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.o62(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.o9n_1.j9g_1.h62(tmp_2, handleGameEnd$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.za1(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function handleGameEnd$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'de.fsaurenbach.sauronchess.client.handleGameEnd.<anonymous>.<anonymous>' call
    return new Wizard();
  };
}
function handleGameEnd$slambda_0() {
  var i = new handleGameEnd$slambda();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function handleGameEnd$lambda($text) {
  return function (it) {
    $text.wad();
    var tmp0_safe_receiver = get_wsClient();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.v33();
    }
    GameState_getInstance().d2q();
    return Unit_instance;
  };
}
function timesUp$lambda(isWhite) {
  _init_properties_Main_kt__xi25uv();
  if (!GameState_getInstance().nby_1) {
    switch (isWhite) {
      case true:
        var tmp = GameState_getInstance().v9v();
        launch(tmp, VOID, VOID, timesUp$lambda$slambda_1());
        break;
      case false:
        var tmp_0 = GameState_getInstance().v9v();
        launch(tmp_0, VOID, VOID, timesUp$lambda$slambda_2());
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  var tmp = sendGameEnd('whiteTime', $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function timesUp$lambda$slambda_1() {
  var i = new timesUp$lambda$slambda();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $this$launch, $completion) {
  var tmp = sendGameEnd('blackTime', $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function timesUp$lambda$slambda_2() {
  var i = new timesUp$lambda$slambda_0();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function sceneContainer$factory() {
  return getPropertyCallableRef('sceneContainer', 1, KMutableProperty1, function (receiver) {
    return receiver.v9v();
  }, function (receiver, value) {
    return receiver.sc6(value);
  });
}
function sceneContainer$factory_0() {
  return getPropertyCallableRef('sceneContainer', 1, KMutableProperty1, function (receiver) {
    return receiver.v9v();
  }, function (receiver, value) {
    return receiver.sc6(value);
  });
}
function settingsContainer$factory() {
  return getPropertyCallableRef('settingsContainer', 1, KMutableProperty1, function (receiver) {
    return receiver.uc6();
  }, function (receiver, value) {
    return receiver.tc6(value);
  });
}
function settingsContainer$factory_0() {
  return getPropertyCallableRef('settingsContainer', 1, KMutableProperty1, function (receiver) {
    return receiver.uc6();
  }, function (receiver, value) {
    return receiver.tc6(value);
  });
}
function click$factory() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
function click$factory_0() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
function down$factory() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.f9s_1;
  }, null);
}
var properties_initialized_Main_kt_gqj46d;
function _init_properties_Main_kt__xi25uv() {
  if (!properties_initialized_Main_kt_gqj46d) {
    properties_initialized_Main_kt_gqj46d = true;
    wsClient = null;
    clientID = get(Default_getInstance(), 1, 1000).toString();
    uniqueIdentifier = null;
  }
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
function moveIndicator(_this__u8e3s4, cx, cy) {
  return addTo_0(MoveIndicator.vc9(cx, cy), _this__u8e3s4);
}
var PieceKind_WhitePawn_instance;
var PieceKind_BlackPawn_instance;
var PieceKind_WhiteRook_instance;
var PieceKind_BlackRook_instance;
var PieceKind_WhiteKnight_instance;
var PieceKind_BlackKnight_instance;
var PieceKind_WhiteBishop_instance;
var PieceKind_BlackBishop_instance;
var PieceKind_WhiteQueen_instance;
var PieceKind_BlackQueen_instance;
var PieceKind_WhiteKing_instance;
var PieceKind_BlackKing_instance;
var PieceKind_entriesInitialized;
function PieceKind_initEntries() {
  if (PieceKind_entriesInitialized)
    return Unit_instance;
  PieceKind_entriesInitialized = true;
  PieceKind_WhitePawn_instance = new PieceKind('WhitePawn', 0);
  PieceKind_BlackPawn_instance = new PieceKind('BlackPawn', 1);
  PieceKind_WhiteRook_instance = new PieceKind('WhiteRook', 2);
  PieceKind_BlackRook_instance = new PieceKind('BlackRook', 3);
  PieceKind_WhiteKnight_instance = new PieceKind('WhiteKnight', 4);
  PieceKind_BlackKnight_instance = new PieceKind('BlackKnight', 5);
  PieceKind_WhiteBishop_instance = new PieceKind('WhiteBishop', 6);
  PieceKind_BlackBishop_instance = new PieceKind('BlackBishop', 7);
  PieceKind_WhiteQueen_instance = new PieceKind('WhiteQueen', 8);
  PieceKind_BlackQueen_instance = new PieceKind('BlackQueen', 9);
  PieceKind_WhiteKing_instance = new PieceKind('WhiteKing', 10);
  PieceKind_BlackKing_instance = new PieceKind('BlackKing', 11);
}
function piece(_this__u8e3s4, kind, color, cx, cy, disabled, isWhite) {
  disabled = disabled === VOID ? false : disabled;
  return addTo_0(Piece.zc9(kind, color, cx, cy, disabled, isWhite), _this__u8e3s4);
}
function *_generator_invoke__zhh2q8_7($this, $this$launch, $completion) {
  var tmp = $this.bca_1.pcc($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  promoteTo($this.aca_1, tmp);
  GameState_getInstance().aby_1 = false;
  $this.bca_1.wad();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $this$launch, $completion) {
  var tmp = ensureNotNull(get_wsClient()).w33(toJson($this.qcc_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function _get_newX__dauvtf($this) {
  return $this.zc5_1.zk_1;
}
function _get_newY__dauvua($this) {
  return $this.zc5_1.al_1;
}
function movePawn($this) {
  var pieceOnNewPos = findPiece(_get_newX__dauvtf($this), _get_newY__dauvua($this));
  var tmp;
  if ($this.xc5_1) {
    tmp = ((_get_newY__dauvua($this) - $this.dc6() | 0) === -1 && $this.cc6() === _get_newX__dauvtf($this));
  } else {
    tmp = ((_get_newY__dauvua($this) - $this.dc6() | 0) === 1 && $this.cc6() === _get_newX__dauvtf($this));
  }
  var isPawnMoveForward = tmp;
  var tmp_0;
  if ($this.xc5_1) {
    tmp_0 = ($this.dc6() === 6 && _get_newY__dauvua($this) === 4 && $this.cc6() === _get_newX__dauvtf($this));
  } else {
    tmp_0 = ($this.dc6() === 1 && _get_newY__dauvua($this) === 3 && $this.cc6() === _get_newX__dauvtf($this));
  }
  var isInitialPawnMove = tmp_0;
  var tmp_1;
  if ($this.xc5_1) {
    tmp_1 = ((_get_newY__dauvua($this) - $this.dc6() | 0) === -1 && abs(_get_newX__dauvtf($this) - $this.cc6() | 0) === 1);
  } else {
    tmp_1 = ((_get_newY__dauvua($this) - $this.dc6() | 0) === 1 && abs($this.cc6() - _get_newX__dauvtf($this) | 0) === 1);
  }
  var isEnPassant = tmp_1;
  if (isPawnMoveForward || isInitialPawnMove) {
    $this.bc6_1 = isInitialPawnMove;
    if (pieceOnNewPos == null) {
      return true;
    }
  } else if (abs(_get_newY__dauvua($this) - $this.dc6() | 0) === 1 && abs(_get_newX__dauvtf($this) - $this.cc6() | 0) === 1) {
    if ($this.xc5_1 && _get_newY__dauvua($this) > $this.dc6() || (!$this.xc5_1 && _get_newY__dauvua($this) < $this.dc6()))
      return false;
    if (!(pieceOnNewPos == null) && !(pieceOnNewPos.xc5_1 === $this.xc5_1)) {
      return true;
    }
  }
  var pawnToTake = findPiece(_get_newX__dauvtf($this), $this.dc6());
  if (isEnPassant && !(pawnToTake == null) && pawnToTake.xc5_1 === !$this.xc5_1 && pawnToTake.bc6_1) {
    GameState_getInstance().fby_1 = pawnToTake;
    return true;
  }
  return false;
}
function moveRook($this) {
  if ($this.cc6() === _get_newX__dauvtf($this)) {
    var range = _get_newY__dauvua($this) > $this.dc6() ? until($this.dc6() + 1 | 0, _get_newY__dauvua($this)) : until(_get_newY__dauvua($this) + 1 | 0, $this.dc6());
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(range, Collection)) {
        tmp = range.g1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var inductionVariable = range.y1_1;
      var last = range.z1_1;
      if (inductionVariable <= last)
        do {
          var element = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'de.fsaurenbach.sauronchess.client.Piece.moveRook.<anonymous>' call
          var it = element;
          if (!(findPiece($this.cc6(), it) == null)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
         while (!(element === last));
      tmp$ret$0 = false;
    }
    if (tmp$ret$0)
      return false;
  } else if ($this.dc6() === _get_newY__dauvua($this)) {
    var range_0 = _get_newX__dauvtf($this) > $this.cc6() ? until($this.cc6() + 1 | 0, _get_newX__dauvtf($this)) : until(_get_newX__dauvtf($this) + 1 | 0, $this.cc6());
    var tmp$ret$2;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(range_0, Collection)) {
        tmp_0 = range_0.g1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$2 = false;
        break $l$block_2;
      }
      var inductionVariable_0 = range_0.y1_1;
      var last_0 = range_0.z1_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'de.fsaurenbach.sauronchess.client.Piece.moveRook.<anonymous>' call
          var it_0 = element_0;
          if (!(findPiece(it_0, $this.dc6()) == null)) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
        }
         while (!(element_0 === last_0));
      tmp$ret$2 = false;
    }
    if (tmp$ret$2)
      return false;
  } else {
    return false;
  }
  return true;
}
function moveKnight($this) {
  var xDiff = abs(_get_newX__dauvtf($this) - $this.cc6() | 0);
  var yDiff = abs(_get_newY__dauvua($this) - $this.dc6() | 0);
  return xDiff === 2 && yDiff === 1 || (xDiff === 1 && yDiff === 2);
}
function moveBishop($this) {
  var dx = abs(_get_newX__dauvtf($this) - $this.cc6() | 0);
  var dy = abs(_get_newY__dauvua($this) - $this.dc6() | 0);
  if (!(dx === dy))
    return false;
  var directionX = get_sign(_get_newX__dauvtf($this) - $this.cc6() | 0);
  var directionY = get_sign(_get_newY__dauvua($this) - $this.dc6() | 0);
  var inductionVariable = 1;
  if (inductionVariable < dx)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var checkPos = to($this.cc6() + imul(i, directionX) | 0, $this.dc6() + imul(i, directionY) | 0);
      if (!(findPiece(checkPos.zk_1, checkPos.al_1) == null)) {
        return false;
      }
    }
     while (inductionVariable < dx);
  return true;
}
function moveQueen($this) {
  return moveRook($this) || moveBishop($this);
}
function moveKing($this) {
  var deltaX = _get_newX__dauvtf($this) - $this.cc6() | 0;
  var deltaY = _get_newY__dauvua($this) - $this.dc6() | 0;
  if (abs(deltaX) <= 1 && abs(deltaY) <= 1)
    return true;
  if (GameState_getInstance().vbx_1 && $this.xc5_1 && $this.cc6() === 4 && $this.dc6() === 7) {
    if (_get_newX__dauvtf($this) === 6 && _get_newY__dauvua($this) === 7) {
      if (!(findPiece(_get_newX__dauvtf($this), _get_newY__dauvua($this)) == null) || !(findPiece(5, 7) == null))
        return false;
      if (!simulateMove($this.yc5_1, $this.zc5_1, $this, true))
        return false;
      GameState_getInstance().bby_1 = true;
      return true;
    } else if (_get_newX__dauvtf($this) === 2 && _get_newY__dauvua($this) === 7) {
      if (!(findPiece(1, 7) == null) || !(findPiece(_get_newX__dauvtf($this), _get_newY__dauvua($this)) == null) || !(findPiece(3, 7) == null))
        return false;
      if (!simulateMove($this.yc5_1, $this.zc5_1, $this, true))
        return false;
      GameState_getInstance().bby_1 = true;
      return true;
    }
  }
  if (GameState_getInstance().wbx_1 && !$this.xc5_1 && $this.cc6() === 4 && $this.dc6() === 0) {
    if (_get_newX__dauvtf($this) === 6 && _get_newY__dauvua($this) === 0) {
      if (!(findPiece(_get_newX__dauvtf($this), _get_newY__dauvua($this)) == null) || !(findPiece(5, 0) == null))
        return false;
      if (!simulateMove($this.yc5_1, $this.zc5_1, $this, true))
        return false;
      GameState_getInstance().bby_1 = true;
      return true;
    } else if (_get_newX__dauvtf($this) === 2 && _get_newY__dauvua($this) === 0) {
      if (!(findPiece(1, 0) == null) || !(findPiece(_get_newX__dauvtf($this), _get_newY__dauvua($this)) == null) || !(findPiece(3, 0) == null))
        return false;
      if (!simulateMove($this.yc5_1, $this.zc5_1, $this, true))
        return false;
      GameState_getInstance().bby_1 = true;
      return true;
    }
  }
  return false;
}
function promoteTo($this, newPieceKind) {
  println('Promoting to ' + newPieceKind.toString());
  $this.uc5_1 = newPieceKind;
  reloadImages($this);
}
function reloadImages($this) {
  if (!($this.ac6_1 == null)) {
    $this.rcc().wad();
  }
  var tmp = $this;
  // Inline function 'korlibs.korge.view.image' call
  var tmp_0;
  switch ($this.uc5_1.k3_1) {
    case 0:
      tmp_0 = ensureNotNull(Images_instance.ec6_1);
      break;
    case 2:
      tmp_0 = ensureNotNull(Images_instance.fc6_1);
      break;
    case 4:
      tmp_0 = ensureNotNull(Images_instance.gc6_1);
      break;
    case 6:
      tmp_0 = ensureNotNull(Images_instance.hc6_1);
      break;
    case 8:
      tmp_0 = ensureNotNull(Images_instance.ic6_1);
      break;
    case 10:
      tmp_0 = ensureNotNull(Images_instance.jc6_1);
      break;
    case 1:
      tmp_0 = ensureNotNull(Images_instance.kc6_1);
      break;
    case 3:
      tmp_0 = ensureNotNull(Images_instance.lc6_1);
      break;
    case 5:
      tmp_0 = ensureNotNull(Images_instance.mc6_1);
      break;
    case 7:
      tmp_0 = ensureNotNull(Images_instance.nc6_1);
      break;
    case 9:
      tmp_0 = ensureNotNull(Images_instance.oc6_1);
      break;
    case 11:
      tmp_0 = ensureNotNull(Images_instance.pc6_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var texture = tmp_0;
  var anchor = Companion_getInstance_1().d25_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = Image.kbf(texture, anchor);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.image.<anonymous>' call
  tmp.ac6_1 = addTo(this_0, $this);
  $this.rcc().fac(DisplayConfig_getInstance().bbx_1);
}
function Piece$lambda(this$0) {
  return function ($this$onMouseDrag, it) {
    this$0.zc5_1 = new Pair(numberToInt($this$onMouseDrag.k9r().c26_1 - DisplayConfig_getInstance().ebx_1) / numberToInt(DisplayConfig_getInstance().fbx()) | 0, numberToInt($this$onMouseDrag.k9r().d26_1 - DisplayConfig_getInstance().hbx()) / numberToInt(DisplayConfig_getInstance().gbx()) | 0);
    var _iterator__ex2g4s = GameState_getInstance().hby_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var whiteCircle = _iterator__ex2g4s.c1();
      whiteCircle.wc9();
    }
    var _iterator__ex2g4s_0 = GameState_getInstance().gby_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var circle = _iterator__ex2g4s_0.c1();
      if (circle.rc9_1 === _get_newX__dauvtf(this$0) && circle.sc9_1 === _get_newY__dauvua(this$0)) {
        circle.yc9();
        GameState_getInstance().hby_1.h(circle);
      }
    }
    return Unit_instance;
  };
}
function Piece$lambda_0(this$0) {
  return function (info) {
    var tmp;
    if ((GameState_getInstance().zbx_1 && this$0.xc5_1 || (!GameState_getInstance().zbx_1 && !this$0.xc5_1)) && !GameState_getInstance().aby_1) {
      if (GameState_getInstance().nby_1) {
        if (!(GameState_getInstance().lby_1 === this$0.xc5_1))
          return Unit_instance;
      }
      this$0.bac(info.g9r());
      this$0.cac(info.h9r());
      tmp = Unit_instance;
    } else {
      return Unit_instance;
    }
    var tmp_0;
    if (info.k9p_1) {
      this$0.dac(3.0);
      scale(this$0, 1.2, 1.2);
      GameState_getInstance().bby_1 = false;
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = GameState_getInstance().gby_1.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'de.fsaurenbach.sauronchess.client.Piece.<anonymous>.<anonymous>' call
        element.wad();
      }
      GameState_getInstance().gby_1.y2();
      var inductionVariable = 0;
      var tmp_1;
      if (inductionVariable <= 7) {
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var inductionVariable_0 = 0;
          if (inductionVariable_0 <= 7)
            do {
              var y = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (simulateMove(this$0.yc5_1, new Pair(x, y), this$0)) {
                // Inline function 'kotlin.also' call
                var this_0 = findCell(x, y);
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'de.fsaurenbach.sauronchess.client.Piece.<anonymous>.<anonymous>' call
                // Inline function 'kotlin.apply' call
                var this_1 = moveIndicator(ensureNotNull(this$0.n24()), x, y);
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'de.fsaurenbach.sauronchess.client.Piece.<anonymous>.<anonymous>.<anonymous>' call
                if (!(findPiece(x, y) == null)) {
                  this_1.xc9();
                } else {
                  this_1.wc9();
                }
                addTo_1(this_1, GameState_getInstance().gby_1);
                centerOn(this_1, ensureNotNull(this_0));
              }
            }
             while (inductionVariable_0 <= 7);
        }
         while (inductionVariable <= 7);
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }
    var tmp_2;
    if (info.l9p_1) {
      this$0.dac(0.0);
      scale(this$0, 1.0, 1.0);
      this$0.wc6(this$0.zc5_1);
      tmp_2 = Unit_instance;
    }
    return Unit_instance;
  };
}
function Piece$doMove$slambda_1(this$0, $promotionDialogue) {
  var i = new Piece$doMove$slambda(this$0, $promotionDialogue);
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function Piece$doMove$slambda_2($map) {
  var i = new Piece$doMove$slambda_0($map);
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function checkGameLegal() {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_0 = GameState_getInstance().ubx_1;
  var destination = ArrayList.i1();
  var tmp0_iterator = this_0.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'de.fsaurenbach.sauronchess.client.checkGameLegal.<anonymous>' call
    if (element.vc5_1 === Colors_getInstance().m3x_1) {
      destination.h(element);
    }
  }
  var whitePieces = destination;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var this_1 = GameState_getInstance().ubx_1;
  var destination_0 = ArrayList.i1();
  var tmp0_iterator_0 = this_1.a1();
  while (tmp0_iterator_0.b1()) {
    var element_0 = tmp0_iterator_0.c1();
    // Inline function 'de.fsaurenbach.sauronchess.client.checkGameLegal.<anonymous>' call
    if (element_0.vc5_1 === Colors_getInstance().n3x_1) {
      destination_0.h(element_0);
    }
  }
  var blackPieces = destination_0;
  var draw = false;
  var checkMate = false;
  var insufficientMaterial;
  if (GameState_getInstance().xbx_1 && GameState_getInstance().zbx_1 || (GameState_getInstance().ybx_1 && !GameState_getInstance().zbx_1)) {
    println('someone is in check');
    var _iterator__ex2g4s = (GameState_getInstance().zbx_1 ? whitePieces : blackPieces).a1();
    while (_iterator__ex2g4s.b1()) {
      var piece = _iterator__ex2g4s.c1();
      var inductionVariable = 0;
      if (inductionVariable <= 7)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var inductionVariable_0 = 0;
          if (inductionVariable_0 <= 7)
            do {
              var y = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (simulateMove(piece.yc5_1, new Pair(x, y), piece)) {
                println('there is still hope');
                return Unit_instance;
              }
            }
             while (inductionVariable_0 <= 7);
        }
         while (inductionVariable <= 7);
    }
    println('GAME IS LEGAL: false');
    checkMate = true;
    var tmp = GameState_getInstance().v9v();
    launch(tmp, VOID, VOID, checkGameLegal$slambda_2());
  }
  var _iterator__ex2g4s_0 = (GameState_getInstance().zbx_1 ? whitePieces : blackPieces).a1();
  while (_iterator__ex2g4s_0.b1()) {
    var piece_0 = _iterator__ex2g4s_0.c1();
    var inductionVariable_1 = 0;
    if (inductionVariable_1 <= 7)
      do {
        var x_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        if (inductionVariable_2 <= 7)
          do {
            var y_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            if (simulateMove(piece_0.yc5_1, to(x_0, y_0), piece_0))
              return Unit_instance;
          }
           while (inductionVariable_2 <= 7);
      }
       while (inductionVariable_1 <= 7);
    draw = true;
    var tmp_0 = GameState_getInstance().v9v();
    launch(tmp_0, VOID, VOID, checkGameLegal$slambda_3());
  }
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var this_2 = GameState_getInstance().ubx_1;
    var tmp_1;
    if (isInterface(this_2, Collection)) {
      tmp_1 = this_2.g1();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp$ret$6 = true;
      break $l$block_0;
    }
    var tmp0_iterator_1 = this_2.a1();
    while (tmp0_iterator_1.b1()) {
      var element_1 = tmp0_iterator_1.c1();
      // Inline function 'de.fsaurenbach.sauronchess.client.checkGameLegal.<anonymous>' call
      if (element_1.uc5_1.equals(PieceKind_WhitePawn_getInstance()) || element_1.uc5_1.equals(PieceKind_BlackPawn_getInstance())) {
        tmp$ret$6 = false;
        break $l$block_0;
      }
    }
    tmp$ret$6 = true;
  }
  if (tmp$ret$6) {
    var tmp_2 = GameState_getInstance().ubx_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_3 = GameState_getInstance().ubx_1;
    var destination_1 = ArrayList.i1();
    var tmp0_iterator_2 = this_3.a1();
    while (tmp0_iterator_2.b1()) {
      var element_2 = tmp0_iterator_2.c1();
      // Inline function 'de.fsaurenbach.sauronchess.client.checkGameLegal.<anonymous>' call
      if (element_2.uc5_1.equals(PieceKind_WhiteKing_getInstance()) || !element_2.xc5_1) {
        destination_1.h(element_2);
      }
    }
    whitePieces = minus(tmp_2, toSet(destination_1));
    var tmp_3 = GameState_getInstance().ubx_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_4 = GameState_getInstance().ubx_1;
    var destination_2 = ArrayList.i1();
    var tmp0_iterator_3 = this_4.a1();
    while (tmp0_iterator_3.b1()) {
      var element_3 = tmp0_iterator_3.c1();
      // Inline function 'de.fsaurenbach.sauronchess.client.checkGameLegal.<anonymous>' call
      if (element_3.uc5_1.equals(PieceKind_BlackKing_getInstance()) || element_3.xc5_1) {
        destination_2.h(element_3);
      }
    }
    blackPieces = minus(tmp_3, toSet(destination_2));
    var tmp_4;
    // Inline function 'kotlin.collections.count' call
    if (whitePieces.d1() > 1) {
      // Inline function 'kotlin.collections.count' call
      tmp_4 = blackPieces.d1() > 1;
    } else {
      tmp_4 = false;
    }
    if (tmp_4)
      return Unit_instance;
    var whiteLegal = false;
    var blackLegal = false;
    var whiteBishopOnWhite = null;
    var blackBishopOnWhite = null;
    var _iterator__ex2g4s_1 = plus(whitePieces, blackPieces).a1();
    while (_iterator__ex2g4s_1.b1()) {
      var piece_1 = _iterator__ex2g4s_1.c1();
      if (piece_1.uc5_1.equals(PieceKind_WhiteKnight_getInstance()))
        whiteLegal = true;
      else if (piece_1.uc5_1.equals(PieceKind_WhiteBishop_getInstance())) {
        var tmp0_safe_receiver = findCell(piece_1.cc6(), piece_1.dc6());
        whiteBishopOnWhite = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ubw_1;
      } else if (piece_1.uc5_1.equals(PieceKind_BlackKnight_getInstance()))
        blackLegal = true;
      else if (piece_1.uc5_1.equals(PieceKind_BlackBishop_getInstance())) {
        var tmp1_safe_receiver = findCell(piece_1.cc6(), piece_1.dc6());
        blackBishopOnWhite = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ubw_1;
      }
    }
    if (whiteLegal || blackLegal)
      return Unit_instance;
    if (!(whiteBishopOnWhite == null) && !(blackBishopOnWhite == null) && whiteBishopOnWhite == blackBishopOnWhite)
      return Unit_instance;
    insufficientMaterial = true;
    var tmp_5 = GameState_getInstance().v9v();
    launch(tmp_5, VOID, VOID, checkGameLegal$slambda_4());
  } else {
    return Unit_instance;
  }
  println('No moves left for white / black!');
  if (GameState_getInstance().zbx_1) {
    if (GameState_getInstance().xbx_1) {
      println('White got checkmated');
    } else {
      println('White got stalemated');
    }
  } else {
    if (GameState_getInstance().ybx_1) {
      println('Black got checkmated');
    } else {
      println('Black got stalemated');
    }
  }
  println('insuffmat: ' + insufficientMaterial + ', checkmate: ' + checkMate + ', draw: ' + draw);
}
function *_generator_invoke__zhh2q8_9($this, $this$launch, $completion) {
  var tmp = sendGameEnd('checkmate', $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function checkGameLegal$slambda_2() {
  var i = new checkGameLegal$slambda();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, $this$launch, $completion) {
  var tmp = sendGameEnd('draw', $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function checkGameLegal$slambda_3() {
  var i = new checkGameLegal$slambda_0();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_11($this, $this$launch, $completion) {
  var tmp = sendGameEnd('draw', $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function checkGameLegal$slambda_4() {
  var i = new checkGameLegal$slambda_1();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function PieceKind_WhitePawn_getInstance() {
  PieceKind_initEntries();
  return PieceKind_WhitePawn_instance;
}
function PieceKind_BlackPawn_getInstance() {
  PieceKind_initEntries();
  return PieceKind_BlackPawn_instance;
}
function PieceKind_WhiteRook_getInstance() {
  PieceKind_initEntries();
  return PieceKind_WhiteRook_instance;
}
function PieceKind_BlackRook_getInstance() {
  PieceKind_initEntries();
  return PieceKind_BlackRook_instance;
}
function PieceKind_WhiteKnight_getInstance() {
  PieceKind_initEntries();
  return PieceKind_WhiteKnight_instance;
}
function PieceKind_BlackKnight_getInstance() {
  PieceKind_initEntries();
  return PieceKind_BlackKnight_instance;
}
function PieceKind_WhiteBishop_getInstance() {
  PieceKind_initEntries();
  return PieceKind_WhiteBishop_instance;
}
function PieceKind_BlackBishop_getInstance() {
  PieceKind_initEntries();
  return PieceKind_BlackBishop_instance;
}
function PieceKind_WhiteQueen_getInstance() {
  PieceKind_initEntries();
  return PieceKind_WhiteQueen_instance;
}
function PieceKind_BlackQueen_getInstance() {
  PieceKind_initEntries();
  return PieceKind_BlackQueen_instance;
}
function PieceKind_WhiteKing_getInstance() {
  PieceKind_initEntries();
  return PieceKind_WhiteKing_instance;
}
function PieceKind_BlackKing_getInstance() {
  PieceKind_initEntries();
  return PieceKind_BlackKing_instance;
}
function PromotionDialogue$getChoice$lambda(this$0, $coroutine) {
  return function (it) {
    var choice = this$0.kcc_1 ? PieceKind_WhiteQueen_getInstance() : PieceKind_BlackQueen_getInstance();
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $coroutine;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(choice);
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
function PromotionDialogue$getChoice$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function PromotionDialogue$getChoice$lambda_1(this$0, $coroutine) {
  return function (it) {
    var choice = this$0.kcc_1 ? PieceKind_WhiteBishop_getInstance() : PieceKind_BlackBishop_getInstance();
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $coroutine;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(choice);
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
function PromotionDialogue$getChoice$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function PromotionDialogue$getChoice$lambda_3(this$0, $coroutine) {
  return function (it) {
    var choice = this$0.kcc_1 ? PieceKind_WhiteRook_getInstance() : PieceKind_BlackRook_getInstance();
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $coroutine;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(choice);
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
function PromotionDialogue$getChoice$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function PromotionDialogue$getChoice$lambda_5(this$0, $coroutine) {
  return function (it) {
    var choice = this$0.kcc_1 ? PieceKind_WhiteKnight_getInstance() : PieceKind_BlackKnight_getInstance();
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $coroutine;
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(choice);
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
function PromotionDialogue$getChoice$lambda_6($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function down$factory_0() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.f9s_1;
  }, null);
}
function down$factory_1() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.f9s_1;
  }, null);
}
function down$factory_2() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.f9s_1;
  }, null);
}
function down$factory_3() {
  return getPropertyCallableRef('down', 1, KProperty1, function (receiver) {
    return receiver.f9s_1;
  }, null);
}
function _set_baseButton__px3tsk($this, _set____db54di) {
  return $this.dcf_1.bo($this, baseButton$factory(), _set____db54di);
}
function _get_baseButton__auv8nc($this) {
  return $this.dcf_1.zn($this, baseButton$factory_0());
}
function handleAutoPromoteClick($this) {
  UserSettings_instance.obx_1 = !UserSettings_instance.obx_1;
  if (UserSettings_instance.obx_1) {
    _get_baseButton__auv8nc($this).bay(Colors_getInstance().p3x_1);
  } else {
    _get_baseButton__auv8nc($this).bay(Colors_getInstance().o3x_1);
  }
}
function handleDarkModeClick($this) {
  UserSettings_instance.nbx_1 = !UserSettings_instance.nbx_1;
  reloadCells();
  if (UserSettings_instance.nbx_1) {
    $this.ecf_1.qch().bay(ThemeColors_getInstance().mbx_1);
    _get_baseButton__auv8nc($this).bay(Colors_getInstance().p3x_1);
  } else {
    $this.ecf_1.qch().bay(ThemeColors_getInstance().jbx_1);
    _get_baseButton__auv8nc($this).bay(Colors_getInstance().o3x_1);
  }
}
function handleAboutClick($this) {
  if (GameState_getInstance().dby_1) {
    var tmp0_safe_receiver = GameState_getInstance().uc6().gab('AboutPage');
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wad();
    }
    GameState_getInstance().dby_1 = false;
    return Unit_instance;
  }
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = $this.ecf_1.qch().w2i();
  var height = $this.ecf_1.qch().x2i();
  var color = RGBA__withAd_impl_cralao(Colors_getInstance().e4d('#000000'), 0.3);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.zbk(Size2D.s2e(width, height), color);
  // Inline function 'kotlin.apply' call
  addTo(this_0, $this);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  // Inline function 'korlibs.korge.view.name' call
  var this_1 = AboutPage.ack($this.ecf_1);
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.name.<anonymous>' call
  this_1.j9j_1 = 'AboutPage';
  centerOnStage(addTo(this_1, GameState_getInstance().uc6()));
  GameState_getInstance().dby_1 = true;
}
function handleExitClick($this) {
  GameState_getInstance().cby_1 = false;
  GameState_getInstance().uc6().wad();
}
function Settings$SettingsButton$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (this$0.ccf_1.k3_1) {
      case 0:
        handleDarkModeClick(this$0);
        tmp = Unit_instance;
        break;
      case 1:
        handleAboutClick(this$0);
        tmp = Unit_instance;
        break;
      case 2:
        handleAutoPromoteClick(this$0);
        tmp = Unit_instance;
        break;
      case 3:
        handleExitClick(this$0);
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function Settings$SettingsButton$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
var SettingsKind_DarkMode_instance;
var SettingsKind_About_instance;
var SettingsKind_AutoPromote_instance;
var SettingsKind_Exit_instance;
var SettingsKind_entriesInitialized;
function SettingsKind_initEntries() {
  if (SettingsKind_entriesInitialized)
    return Unit_instance;
  SettingsKind_entriesInitialized = true;
  SettingsKind_DarkMode_instance = new SettingsKind('DarkMode', 0);
  SettingsKind_About_instance = new SettingsKind('About', 1);
  SettingsKind_AutoPromote_instance = new SettingsKind('AutoPromote', 2);
  SettingsKind_Exit_instance = new SettingsKind('Exit', 3);
}
function SettingsKind_DarkMode_getInstance() {
  SettingsKind_initEntries();
  return SettingsKind_DarkMode_instance;
}
function SettingsKind_About_getInstance() {
  SettingsKind_initEntries();
  return SettingsKind_About_instance;
}
function SettingsKind_AutoPromote_getInstance() {
  SettingsKind_initEntries();
  return SettingsKind_AutoPromote_instance;
}
function SettingsKind_Exit_getInstance() {
  SettingsKind_initEntries();
  return SettingsKind_Exit_instance;
}
function showSettings() {
  var tmp = GameState_getInstance();
  // Inline function 'korlibs.korge.view.container' call
  var this_0 = GameState_getInstance().v9v();
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Container.g9y(false);
  // Inline function 'kotlin.apply' call
  var this_2 = addTo(this_1, this_0);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.container.<anonymous>' call
  tmp.tc6(this_2);
  // Inline function 'korlibs.korge.view.solidRect' call
  var this_3 = GameState_getInstance().uc6();
  var width = DisplayConfig_getInstance().cbx_1 + 18;
  var height = DisplayConfig_getInstance().dbx_1 + 18;
  var color = RGBA__withAd_impl_cralao(Colors_getInstance().e4d('#000000'), 0.6);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = SolidRect.zbk(Size2D.s2e(width, height), color);
  // Inline function 'kotlin.apply' call
  var this_5 = addTo(this_4, this_3);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  centerOnStage(this_5);
  centerOnStage(addTo(Settings.cck(), GameState_getInstance().uc6()));
  GameState_getInstance().cby_1 = true;
}
function background$factory() {
  return getPropertyCallableRef('background', 1, KMutableProperty1, function (receiver) {
    return receiver.qch();
  }, function (receiver, value) {
    return receiver.dck(value);
  });
}
function background$factory_0() {
  return getPropertyCallableRef('background', 1, KMutableProperty1, function (receiver) {
    return receiver.qch();
  }, function (receiver, value) {
    return receiver.dck(value);
  });
}
function click$factory_1() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
function baseButton$factory() {
  return getPropertyCallableRef('baseButton', 1, KMutableProperty1, function (receiver) {
    return _get_baseButton__auv8nc(receiver);
  }, function (receiver, value) {
    return _set_baseButton__px3tsk(receiver, value);
  });
}
function baseButton$factory_0() {
  return getPropertyCallableRef('baseButton', 1, KMutableProperty1, function (receiver) {
    return _get_baseButton__auv8nc(receiver);
  }, function (receiver, value) {
    return _set_baseButton__px3tsk(receiver, value);
  });
}
function *_generator_invoke__zhh2q8_12($this, $this$launch, $completion) {
  println('Trying to connect to server');
  var client = Companion_getInstance_6().q29();
  try {
    var tmp = endpoint(client, 'http' + get_protocolSecurity() + '://' + get_serverAddress() + ':' + get_serverPort()).g33(Companion_getInstance_7().s2z_1, 'check', VOID, VOID, VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    GameState_getInstance().nby_1 = true;
    println('Online play enabled!');
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      GameState_getInstance().nby_1 = false;
      println('Server offline, disabling online play: ' + e.toString());
      _get_onlinePlayButton__mhrjm($this.pcm_1).bay(Colors_getInstance().o3x_1);
      _get_whiteQueen__npyxpm($this.pcm_1).h8g(false);
      _get_blackQueen__p74i9s($this.pcm_1).h8g(false);
      _get_offlinePlayButton__fnvz54($this.pcm_1).h8g(true);
      removeSlots($this.pcm_1);
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $this$launch, $completion) {
  var tmp = endpoint(Companion_getInstance_6().q29(), 'http' + get_protocolSecurity() + '://' + get_serverAddress() + ':' + get_serverPort()).g33(Companion_getInstance_7().s2z_1, 'get_slot' + GameState_getInstance().mby_1, VOID, VOID, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var response = tmp;
  var tmp_0 = decode(response, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = fromJson(tmp_0);
  var map = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : THROW_CCE();
  println('Slot map (Slot: ' + GameState_getInstance().mby_1 + '): ' + toString_1(map));
  _get_whiteQueen__npyxpm($this.qcm_1).h8g(true);
  _get_blackQueen__p74i9s($this.qcm_1).h8g(true);
  if (!(map.d3('player1') == null)) {
    println('player1 is already used ' + toString_0(map.d3('player1')));
    $this.qcm_1.dcn_1 = false;
    _get_whiteQueen__npyxpm($this.qcm_1).h8g(false);
  }
  if (!(map.d3('player2') == null)) {
    println('player2 is already used ' + toString_0(map.d3('player2')));
    $this.qcm_1.ecn_1 = false;
    _get_blackQueen__p74i9s($this.qcm_1).h8g(false);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $this$launch, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = GameState_getInstance().v9v();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.p9n_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.o9n_1.j9g_1.f62().d62(getKClass(SceneContainer), this_0).d62(getKClass(Resources), new Resources(this_0.ds(), this_0.o9n_1.q9o().y33_1, this_0.o9n_1.q9o()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.d62(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'de.fsaurenbach.sauronchess.client.Wizard.changeScene.<anonymous>.<anonymous>' call
  var newScene = new GameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance().xa1_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.k2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString_1(clazz) + ' ... ' + toString_1(newScene);
    this_1.l2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.o62(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.o9n_1.j9g_1.h62(tmp_2, Wizard$changeScene$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.za1(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function Wizard$changeScene$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'de.fsaurenbach.sauronchess.client.Wizard.changeScene.<anonymous>.<anonymous>' call
    return new GameScene();
  };
}
function _get_whiteQueen__npyxpm($this) {
  var tmp = $this.fcn_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('whiteQueen');
  }
}
function _get_blackQueen__p74i9s($this) {
  var tmp = $this.gcn_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('blackQueen');
  }
}
function _get_onlinePlayButton__mhrjm($this) {
  var tmp = $this.jcn_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('onlinePlayButton');
  }
}
function _get_offlinePlayButton__fnvz54($this) {
  var tmp = $this.kcn_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('offlinePlayButton');
  }
}
function updateColors($this) {
  var _iterator__ex2g4s = $this.ccn_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var rr = _iterator__ex2g4s.c1();
    rr.mcm_1.bay(GameState_getInstance().mby_1 === rr.ncm_1 ? Colors_getInstance().p3x_1 : Colors_getInstance().o3x_1);
  }
}
function *_generator_sceneMain__5xvlzl_0(_this__u8e3s4, $this, $completion) {
  var tmp = reloadPictures($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this;
  // Inline function 'korlibs.korge.view.roundRect' call
  var size = Size2D.j27(200, 100);
  var radius = $this.icn_1;
  var fill = new RGBA(ThemeColors_getInstance().jbx_1);
  var stroke = new RGBA(Colors_getInstance().m3x_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = RoundRect.qbi(size, radius, fill, stroke, 0.0, true);
  // Inline function 'kotlin.apply' call
  var this_1 = addTo(this_0, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  tmp_0.kcn_1 = centerOnStage(this_1);
  // Inline function 'korlibs.korge.input.onClick' call
  var this_2 = _get_offlinePlayButton__fnvz54($this);
  var handler = Wizard$sceneMain$lambda($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop = click$factory_2();
  var tmp1_safe_receiver = this_2 == null ? null : this_2.oab();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.d1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.f1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1 = prop.get(tmp1_safe_receiver_0);
        tmp_1.x1w(Wizard$sceneMain$lambda_0(handler));
      }
    }
  }
  // Inline function 'korlibs.korge.view.text' call
  var text = 'Play Offline';
  var color = ThemeColors_getInstance().kbx_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance_3().s4l_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance.dbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = Text.gbp(text, numberToDouble(40), color, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_4 = addTo(this_3, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  centerOn(addTo_0(this_4, _get_offlinePlayButton__fnvz54($this)), _get_offlinePlayButton__fnvz54($this));
  var tmp_2 = $this;
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.roundRect' call
  var size_0 = $this.hcn_1;
  var radius_0 = $this.icn_1;
  var fill_0 = new RGBA(ThemeColors_getInstance().jbx_1);
  var stroke_0 = new RGBA(Colors_getInstance().m3x_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = RoundRect.qbi(size_0, radius_0, fill_0, stroke_0, 0.0, true);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'de.fsaurenbach.sauronchess.client.Wizard.sceneMain.<anonymous>' call
  centerYOnStage(this_6);
  // Inline function 'korlibs.korge.view.positionX' call
  var x = DisplayConfig_getInstance().zbw_1 / 3 | 0;
  positionX(this_6, numberToDouble(x));
  this_6.dab(centerOn(Image.kbf(ensureNotNull(Images_instance.ic6_1)), this_6));
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_0 = Wizard$sceneMain$lambda_1($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_0 = click$factory_3();
  var tmp1_safe_receiver_1 = this_6 == null ? null : this_6.oab();
  if (tmp1_safe_receiver_1 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_safe_receiver_1.d1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.f1(_unary__edvuaz_0);
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
      if (tmp1_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_3 = prop_0.get(tmp1_safe_receiver_2);
        tmp_3.x1w(Wizard$sceneMain$lambda_2(handler_0));
      }
    }
  }
  this_6.h8g(false);
  tmp_2.fcn_1 = addTo_0(this_6, _this__u8e3s4);
  var tmp_4 = $this;
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.roundRect' call
  var size_1 = $this.hcn_1;
  var radius_1 = $this.icn_1;
  var fill_1 = new RGBA(ThemeColors_getInstance().jbx_1);
  var stroke_1 = new RGBA(Colors_getInstance().m3x_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_7 = RoundRect.qbi(size_1, radius_1, fill_1, stroke_1, 0.0, true);
  // Inline function 'kotlin.apply' call
  var this_8 = addTo(this_7, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'de.fsaurenbach.sauronchess.client.Wizard.sceneMain.<anonymous>' call
  centerYOnStage(this_8);
  // Inline function 'korlibs.korge.view.positionX' call
  var x_0 = (DisplayConfig_getInstance().zbw_1 / 3 | 0) + (DisplayConfig_getInstance().zbw_1 / 3 | 0) | 0;
  positionX(this_8, numberToDouble(x_0));
  this_8.dab(centerOn(Image.kbf(ensureNotNull(Images_instance.oc6_1)), this_8));
  // Inline function 'korlibs.korge.input.onClick' call
  var handler_1 = Wizard$sceneMain$lambda_3($this);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_1 = click$factory_4();
  var tmp1_safe_receiver_3 = this_8 == null ? null : this_8.oab();
  if (tmp1_safe_receiver_3 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp1_safe_receiver_3.d1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_1 = n_1;
      n_1 = _unary__edvuaz_1 + 1 | 0;
      var tmp0_safe_receiver_1 = tmp1_safe_receiver_3.f1(_unary__edvuaz_1);
      var tmp1_safe_receiver_4 = tmp0_safe_receiver_1 == null ? null : get_mouse(tmp0_safe_receiver_1);
      if (tmp1_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_5 = prop_1.get(tmp1_safe_receiver_4);
        tmp_5.x1w(Wizard$sceneMain$lambda_4(handler_1));
      }
    }
  }
  this_8.h8g(false);
  tmp_4.gcn_1 = addTo_0(this_8, _this__u8e3s4);
  var tmp_6 = $this;
  // Inline function 'kotlin.apply' call
  // Inline function 'korlibs.korge.view.roundRect' call
  var size_2 = $this.hcn_1;
  var radius_2 = $this.icn_1;
  var fill_2 = new RGBA(Colors_getInstance().m3x_1);
  var stroke_2 = new RGBA(Colors_getInstance().m3x_1);
  // Inline function 'korlibs.korge.view.addTo' call
  var this_9 = RoundRect.qbi(size_2, radius_2, fill_2, stroke_2, 0.0, true);
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(this_9, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'de.fsaurenbach.sauronchess.client.Wizard.sceneMain.<anonymous>' call
  this_10.bay(Colors_getInstance().o3x_1);
  tmp_6.jcn_1 = this_10;
  // Inline function 'korlibs.korge.view.zIndex' call
  // Inline function 'korlibs.korge.view.text' call
  var text_0 = 'Play\nOnline';
  var color_0 = Colors_getInstance().m3x_1;
  var font_0 = get_DefaultTtfFontAsBitmap();
  var alignment_0 = Companion_getInstance_3().s4l_1;
  var renderer_0 = get_DefaultStringTextRenderer();
  var autoScaling_0 = Companion_instance.dbp_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_11 = Text.gbp(text_0, numberToDouble(30), color_0, font_0, alignment_0, renderer_0, autoScaling_0, null, null);
  // Inline function 'kotlin.apply' call
  var this_12 = addTo(this_11, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  var tmp$ret$38 = zIndex(this_12, numberToDouble(5));
  centerOn(tmp$ret$38, _get_onlinePlayButton__mhrjm($this));
  if (UserSettings_instance.qbx_1) {
    _get_onlinePlayButton__mhrjm($this).bay(Colors_getInstance().p3x_1);
    GameState_getInstance().nby_1 = true;
    updateOnline(_this__u8e3s4, $this);
  }
  // Inline function 'korlibs.korge.input.onClick' call
  var this_13 = _get_onlinePlayButton__mhrjm($this);
  var handler_2 = Wizard$sceneMain$lambda_5($this, _this__u8e3s4);
  // Inline function 'korlibs.korge.input.doMouseEvent' call
  var prop_2 = click$factory_5();
  var tmp1_safe_receiver_5 = this_13 == null ? null : this_13.oab();
  if (tmp1_safe_receiver_5 == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_2 = 0;
    while (n_2 < tmp1_safe_receiver_5.d1()) {
      // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
      var _unary__edvuaz_2 = n_2;
      n_2 = _unary__edvuaz_2 + 1 | 0;
      var tmp0_safe_receiver_2 = tmp1_safe_receiver_5.f1(_unary__edvuaz_2);
      var tmp1_safe_receiver_6 = tmp0_safe_receiver_2 == null ? null : get_mouse(tmp0_safe_receiver_2);
      if (tmp1_safe_receiver_6 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_7 = prop_2.get(tmp1_safe_receiver_6);
        tmp_7.x1w(Wizard$sceneMain$lambda_6(handler_2));
      }
    }
  }
  return Unit_instance;
}
function removeSlots($this) {
  var _iterator__ex2g4s = $this.ccn_1.a1();
  while (_iterator__ex2g4s.b1()) {
    var slot = _iterator__ex2g4s.c1();
    slot.wad();
  }
  $this.ccn_1.y2();
}
function updateOnline(_this__u8e3s4, $this) {
  var tmp = launch($this, VOID, VOID, Wizard$updateOnline$slambda_0($this));
  tmp.et(Wizard$updateOnline$lambda($this, _this__u8e3s4));
}
function updateSlots($this) {
  updateColors($this);
  launch($this, VOID, VOID, Wizard$updateSlots$slambda_0($this));
}
function changeScene($this, isWhite) {
  GameState_getInstance().lby_1 = isWhite;
  var tmp = GameState_getInstance().v9v();
  launch(tmp, VOID, VOID, Wizard$changeScene$slambda_0());
}
function Wizard$sceneMain$lambda(this$0) {
  return function (it) {
    changeScene(this$0, true);
    return Unit_instance;
  };
}
function Wizard$sceneMain$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function Wizard$sceneMain$lambda_1(this$0) {
  return function (it) {
    changeScene(this$0, true);
    return Unit_instance;
  };
}
function Wizard$sceneMain$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function Wizard$sceneMain$lambda_3(this$0) {
  return function (it) {
    changeScene(this$0, false);
    return Unit_instance;
  };
}
function Wizard$sceneMain$lambda_4($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function Wizard$sceneMain$lambda_5(this$0, $this_sceneMain) {
  return function (it) {
    var tmp;
    if (_get_onlinePlayButton__mhrjm(this$0).o53() === Colors_getInstance().p3x_1) {
      _get_onlinePlayButton__mhrjm(this$0).bay(Colors_getInstance().o3x_1);
      GameState_getInstance().nby_1 = false;
      removeSlots(this$0);
      tmp = Unit_instance;
    } else {
      _get_onlinePlayButton__mhrjm(this$0).bay(Colors_getInstance().p3x_1);
      GameState_getInstance().nby_1 = true;
      updateOnline($this_sceneMain, this$0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Wizard$sceneMain$lambda_6($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function Wizard$updateOnline$slambda_0(this$0) {
  var i = new Wizard$updateOnline$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function Wizard$updateOnline$lambda$lambda($slot, this$0) {
  return function (it) {
    GameState_getInstance().mby_1 = $slot.ncm_1;
    updateSlots(this$0);
    return Unit_instance;
  };
}
function Wizard$updateOnline$lambda$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function Wizard$updateOnline$lambda(this$0, $this_updateOnline) {
  return function (it) {
    _get_whiteQueen__npyxpm(this$0).h8g(GameState_getInstance().nby_1);
    _get_blackQueen__p74i9s(this$0).h8g(GameState_getInstance().nby_1);
    _get_offlinePlayButton__fnvz54(this$0).h8g(!GameState_getInstance().nby_1);
    var tmp;
    if (GameState_getInstance().nby_1) {
      var inductionVariable = 0;
      var last = this$0.bcn_1;
      if (inductionVariable <= last)
        do {
          var integer = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_0 = Slot.ocm(RoundRect.qbi(this$0.hcn_1, this$0.icn_1), integer);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'de.fsaurenbach.sauronchess.client.Wizard.updateOnline.<anonymous>.<anonymous>' call
          addTo_0(this_0, $this_updateOnline);
          addTo_1(this_0, this$0.ccn_1);
          // Inline function 'korlibs.korge.view.positionX' call
          var x = imul(DisplayConfig_getInstance().zbw_1 / 5 | 0, integer);
          positionX(this_0, numberToDouble(x));
          // Inline function 'korlibs.korge.view.positionY' call
          var y = DisplayConfig_getInstance().abx_1 / 4 | 0;
          positionY(this_0, numberToDouble(y));
          // Inline function 'korlibs.korge.view.zIndex' call
          zIndex(this_0, numberToDouble(5));
          updateColors(this$0);
        }
         while (!(integer === last));
      var _iterator__ex2g4s = this$0.ccn_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var slot = _iterator__ex2g4s.c1();
        updateSlots(this$0);
        // Inline function 'korlibs.korge.input.onClick' call
        var handler = Wizard$updateOnline$lambda$lambda(slot, this$0);
        // Inline function 'korlibs.korge.input.doMouseEvent' call
        var prop = click$factory_6();
        var tmp1_safe_receiver = slot == null ? null : slot.oab();
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.datastructure.iterators.fastForEach' call
          var n = 0;
          while (n < tmp1_safe_receiver.d1()) {
            // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            var tmp0_safe_receiver = tmp1_safe_receiver.f1(_unary__edvuaz);
            var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
            if (tmp1_safe_receiver_0 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              var tmp_0 = prop.get(tmp1_safe_receiver_0);
              tmp_0.x1w(Wizard$updateOnline$lambda$lambda_0(handler));
            }
          }
        }
      }
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Wizard$updateSlots$slambda_0(this$0) {
  var i = new Wizard$updateSlots$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function Wizard$changeScene$slambda_0() {
  var i = new Wizard$changeScene$slambda();
  var l = function ($this$launch, $completion) {
    return i.h1b($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function *_generator_decode__skqvkq(_this__u8e3s4, $completion) {
  var tmp = readAll(_this__u8e3s4.g2z_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return decodeToString(tmp);
}
function decode(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq.bind(VOID, _this__u8e3s4), $completion);
}
function click$factory_2() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
function click$factory_3() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
function click$factory_4() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
function click$factory_5() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
function click$factory_6() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.c9s_1;
  }, null);
}
//region block: post-declaration
initMetadataForClass(Cell, 'Cell');
initMetadataForClass(Timer, 'Timer');
initMetadataForClass(ChessClockContainer, 'ChessClockContainer', ChessClockContainer.lc3);
initMetadataForObject(GameState, 'GameState');
initMetadataForObject(Images, 'Images');
initMetadataForObject(DisplayConfig, 'DisplayConfig');
initMetadataForObject(ThemeColors, 'ThemeColors');
initMetadataForObject(UserSettings, 'UserSettings');
initMetadataForLambda(GameScene$sceneMain$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$lambda$slambda_0, VOID, VOID, [1]);
initMetadataForClass(GameScene, 'GameScene', GameScene, VOID, VOID, [0]);
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
initMetadataForLambda(sendGameEnd$slambda, VOID, VOID, [1]);
initMetadataForLambda(handleGameEnd$slambda, VOID, VOID, [1]);
initMetadataForLambda(timesUp$lambda$slambda, VOID, VOID, [1]);
initMetadataForLambda(timesUp$lambda$slambda_0, VOID, VOID, [1]);
initMetadataForClass(MoveIndicator, 'MoveIndicator');
initMetadataForClass(PieceKind, 'PieceKind');
initMetadataForLambda(Piece$doMove$slambda, VOID, VOID, [1]);
initMetadataForLambda(Piece$doMove$slambda_0, VOID, VOID, [1]);
initMetadataForClass(Piece, 'Piece');
initMetadataForLambda(checkGameLegal$slambda, VOID, VOID, [1]);
initMetadataForLambda(checkGameLegal$slambda_0, VOID, VOID, [1]);
initMetadataForLambda(checkGameLegal$slambda_1, VOID, VOID, [1]);
initMetadataForClass(PromotionDialogue, 'PromotionDialogue', VOID, VOID, VOID, [0]);
initMetadataForClass(AboutPage, 'AboutPage');
initMetadataForClass(SettingsButton, 'SettingsButton');
initMetadataForClass(SettingsKind, 'SettingsKind');
initMetadataForClass(Settings, 'Settings', Settings.cck);
initMetadataForClass(Slot, 'Slot');
initMetadataForLambda(Wizard$updateOnline$slambda, VOID, VOID, [1]);
initMetadataForLambda(Wizard$updateSlots$slambda, VOID, VOID, [1]);
initMetadataForLambda(Wizard$changeScene$slambda, VOID, VOID, [1]);
initMetadataForClass(Wizard, 'Wizard', Wizard, VOID, VOID, [0]);
//endregion
//region block: init
Images_instance = new Images();
UserSettings_instance = new UserSettings();
//endregion
mainWrapper();
